import { ProfileLocationsAPI } from '../components/my-profile/profile-locations-api';
import { GooglePlacesMapManager } from '../components/my-profile/google-places-map-manager';
import { ProfileImportReviews } from '../components/my-profile/profile-import-reviews';
import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import { _t, number_format } from '@bark/bark-core';
import { exposeQuickScrollToWindow, PaginationManager } from "@bark/bark-core";
import moment from 'moment';

export default async function () {
	try {
		exposeQuickScrollToWindow();
		const formManager = FormManager();

		var MyProfileSettings = function () {
			'use strict';

			$('.card-header')
				.off('click.cardheader')
				.on('click.cardheader', function (e) {
					e.preventDefault();
					if (formManager.checkNavSafe()) {
						const psAnchor = $(this).data('target').substr(1);
						QS.setValue('ps', psAnchor);
						if (psAnchor === 'reviews' && !readReviewNotifications) {
							Bark.api(
								'seller/review/read/',
								{},
								function (data) {
									if (data.status) {
										readReviewNotifications = true;
									}
								},
								function (data) {},
								'POST',
								Bark.apiVersionHeader('v2'),
							);
						}
					} else {
						e.stopPropagation();
					}
				});

			function GeneralInformation() {
				var sellerData,
					cameraVideo,
					cameraVideoStream,
					cameraContext,
					t = this;
				let oldStyleCompanyLocation = null;
				var instanceVars = {
					formManagerHandle: 'profile-gen-info',
					formManagerHandleUser: 'profile-gen-info-usr',
					cameraTemplate: Handlebars.compile(
						document.getElementById('camera-template').innerHTML,
					),
					fieldMappings: {
						company: {
							name: 'company_name',
							isImage: false,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						sales_email: {
							name: 'company_email_address',
							isImage: false,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						company_phone_number: {
							name: 'company_phone_number',
							isImage: false,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						city: {
							name: 'company_city_town',
							isImage: false,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						description: {
							name: 'company_description',
							isImage: false,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						links: {
							name: 'company_website',
							isImage: false,
							overrideSellerDataKey: 'links.website',
							fieldType: 'seller',
						},
						company_logo: {
							name: 'company_logo',
							isImage: true,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
						chat_avatar: {
							name: 'profile_picture',
							isImage: true,
							overrideSellerDataKey: false,
							fieldType: 'seller',
						},
					},
					resetImageFields: () => {
						t.iterateOverFieldMappings((field, key) => {
							if (field.isImage) {
								let fieldElement = t.getMappedFieldElement(field);
								const fileElement = $('[name="' + field.name + '_file"]');
								const newRefElement = $('[name="' + field.name + '_new_ref"]');
								const defaultImageElement = $('[name="default_' + field.name + '"]');
								if (fieldElement.data('original')) {
									fieldElement.attr('src', fieldElement.data('original'));
								} else {
									fieldElement.attr('src', '').addClass('d-none');
									defaultImageElement.removeClass('d-none').addClass('d-inline-flex');
								}
								fileElement.val('');
								newRefElement.val('');
								removeFormErrors(fileElement.parent());
							}
						});
					},
					resetCancellableFields: function () {
						formManager.dirty(t.formManagerHandle, false);
						$('[data-cancellable]').each(function (i) {
							$(this).val($(this).data('original'));
							removeFormErrors($(this).parent());
						});
					},
					getMappedFieldElement: function (field) {
						return $(`[name="${field.name}"]`);
					},
					iterateOverFieldMappings: function (callback) {
						Object.keys(t.fieldMappings).map((fieldKey) => {
							callback(t.fieldMappings[fieldKey], fieldKey);
						});
					},
					fieldIsMapped: function (key) {
						return t.fieldMappings.hasOwnProperty(key);
					},
					getOverrideDataAttribute: function (overrideKey, dataObj) {
						let subkeys = overrideKey.split('.');
						let attribute = dataObj;
						subkeys.map((keyName) => {
							attribute = attribute[keyName];
						});
						return attribute;
					},
					initialise: function () {
						var sellerDataRcvd = $.Deferred();
						formManager.register(
							t.formManagerHandle,
							function (defer) {
								t.saveSellerInfo(defer);
							},
							function () {
								t.resetCancellableFields();
								t.resetImageFields();
								$('#contact_details_enabled').prop(
									'checked',
									$('#contact_details_enabled').data('original'),
								);
								$('#contact_buttons_enabled').prop(
									'checked',
									$('#contact_buttons_enabled').data('original'),
								);
							},
						);
						formManager.register(
							t.formManagerHandleUser,
							function (defer) {
								t.saveUserInfo(defer);
							},
							function () {
								t.resetCancellableFields();
							},
						);
						// todo this should be part of a cleaner api call
						// Check to see if the user is an Elite Pro
						Bark.api(
							'seller/subscriptions/',
							{},
							function (data) {
								if (data.data.length) {
									$('.contact-settings-container').removeClass('d-none');
								}
							},
							function (e) {
								let msg = handleErrors(e, 'Error getting elite pro on settings page');
								bugsnagClient.notify(new Error(msg.message));
							},
						);
						this.addListeners();
						this.handleCompanyInfoSection();
						this.handleExperiments();
					},
					populateData: function (sellerData) {
						t.iterateOverFieldMappings((field, key) => {
							if (!field.isImage) {
								const fieldElement = t.getMappedFieldElement(field);
								let seller_data = sellerData[key];

								if (field.name === 'company_name') {
									seller_data = seller_data.replaceAll("&amp;", "&");
								}

								fieldElement.val(
									field.overrideSellerDataKey
										? t.getOverrideDataAttribute(field.overrideSellerDataKey, sellerData)
										: seller_data,
								);

								fieldElement.data(
									'original',
									field.overrideSellerDataKey
										? t.getOverrideDataAttribute(field.overrideSellerDataKey, sellerData)
										: sellerData[key],
								);
								fieldElement.data('field-type', field.fieldType);
								if (field.name === 'company_city_town') {
									oldStyleCompanyLocation = sellerData[key];
								}
							}
						});

						$('.company-name-logo-container').removeClass('waiting');
						$('.company-contact-details-container').removeClass('waiting');
						$('.company-location-container').removeClass('waiting');
						$('.name-profile-picture-container').removeClass('waiting');
						$('.company-description-container').removeClass('waiting');
						$('#contact_details_enabled')
							.prop('checked', sellerData.contact_details_enabled)
							.data('original', sellerData.contact_details_enabled);
						$('#contact_buttons_enabled')
							.prop('checked', sellerData.contact_buttons_enabled)
							.data('original', sellerData.contact_buttons_enabled);

						if (sellerData.avatar_url && sellerData.avatar_url != '') {
							var thumbnail = sellerData.avatar_url_thumbnail
								? sellerData.avatar_url_thumbnail
								: sellerData.avatar_url;

							$('[name="company_logo"]').attr('src', thumbnail).show();
							$('[name="company_logo"]').data('original', thumbnail);
						} else {
							$('[name="company_logo"]').data('original', false);
						}

						const profileName = sellerData.seller_name.replaceAll("&amp;", "&");

						$('[name="profile_name"]').val(profileName);
						$('[name="profile_name"]').data('original', profileName);
						$('[name="profile_name"]').data('field-type', 'user');

						if (sellerData.chat_avatar && sellerData.chat_avatar != '') {
							var thumbnail = sellerData.chat_avatar_thumbnail
								? sellerData.chat_avatar_thumbnail
								: sellerData.chat_avatar;

							$('[name="profile_picture"]').attr('src', thumbnail).show();
							$('[name="profile_picture"]').data('original', thumbnail);
						} else {
							$('[name="profile_picture"]').data('original', false);
						}
						t.sellerData = sellerData;
						let success = 0;
						if (sellerData.description && sellerData.description.length) success += 1;
						sectionLoaded($('.general-information-container'));
						this.handleLocationSection();
					},
					showCameraModal: function () {
						var t = this;
						modalManager.set(
							_t('seller_settings_photo-video:webcam.title'),
							'',
							this.cameraTemplate({}),
							[
								modalManager.cancelLinkHTML(),
								modalManager.submitButtonHTML(_t('seller_settings_profile:accordion-buttons.add-photo'), true),
							],
							['modal-sm'],
						);
						modalManager.setEvent('click', '.camera-save', {}, function (e) {
							t.cameraContext.drawImage(
								t.cameraVideo,
								Math.min(0, ((t.cameraVideo.videoWidth - 300) / 2) * -1) * -1,
								Math.min(0, ((t.cameraVideo.videoHeight - 300) / 2) * -1) * -1,
								Math.min(300, t.cameraVideo.videoWidth),
								Math.min(300, t.cameraVideo.videoHeight),
								Math.min(0, (t.cameraVideo.videoWidth - 300) / 2) * -1,
								Math.min(0, (t.cameraVideo.videoHeight - 300) / 2) * -1,
								Math.min(300, t.cameraVideo.videoWidth),
								Math.min(300, t.cameraVideo.videoHeight),
							);
							$('.camera-video').hide();
							$('.camera-photo').show();
							$('.camera-save-container').hide();
							$('.camera-retake-container').show();
							$('.modal-submit').prop('disabled', false);
						});
						modalManager.setEvent('click', '.camera-retake', {}, function (e) {
							$('.camera-photo').hide();
							$('.camera-video').show();
							$('.camera-retake-container').hide();
							$('.camera-save-container').show();
							$('.modal-submit').prop('disabled', true);
						});

						modalManager.setEvent('hide.bs.modal', null, {}, function (e) {
							t.cameraVideoStream.getTracks().forEach(function (track) {
								track.stop();
							});
							t.cameraVideo.srcObject = null;
						});
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							var camera_picture = document.getElementById('camera-photo');
							$('#profile_picture').show().attr('src', camera_picture.toDataURL());

							t.cameraVideoStream.getTracks().forEach(function (track) {
								track.stop();
							});
							t.cameraVideo.srcObject = null;

							modalManager.destroy();
							var formData = new FormData();
							var imageFile = fetch($('.profile_picture').attr('src'))
								.then(function (res) {
									return res.arrayBuffer();
								})
								.then(function (buf) {
									return new File([buf], 'image.png', { type: 'image/png' });
								})
								.then(function (file) {
									formData.append('image', file);
									formData.append('type', 'chat-avatar');
									Bark.api(
										'seller/image',
										formData,
										function (data) {
											$('#profile_picture').show().attr('src', data.preview);
											$('#profile_picture_new_ref').val(data.ref);
											formManager.dirty(t.formManagerHandle);
										},
										function (error) {
											var msg = handleErrors(error, _t('seller_settings_photo-video:webcam.error-saving'));
											addFormError($('#profile_photo_div'), msg);
										},
										'POST',
										Bark.apiVersionHeader('v2'),
										false,
										false,
										false,
									);
								});
						});
					},
					showNoCameraModal: function () {
						modalManager.set(
							_t("seller_settings_profile:about.name-profile-pic-section.errors.no-webcam"),
							'',
							// "Please check your settings and try again",
							'<div class="d-flex justify-content-center align-items-center  text-grey-600 my-0"><p class="mb-0">' + _t('seller_settings_photo-video:webcam.check-settings') + '</p></div>',
							[
								'<div class="mx-auto">' +
									modalManager.submitButtonHTML(_t('seller_settings_photo-video:webcam.ok-button'), false) +
									'</div>',
							],
							['modal-sm'],
						);
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							modalManager.destroy();
						});
					},
					createSellerParams: function () {
						var sellerParams = {};
						t.iterateOverFieldMappings((field, key) => {
							const fieldElement = t.getMappedFieldElement(field);
							if (!field.isImage && fieldElement.data('original') != fieldElement.val()) {
								sellerParams[key] = fieldElement.val();
							}
						});
						if (
							$('[name="company_email_address"]').data('original') !=
							$('[name="company_email_address"]').val()
						) {
							var email = $('[name="company_email_address"]').val();
							sellerParams['sales_email'] = email.toLowerCase();
						}
						if (
							$('[name="company_website"]').data('original') !=
							$('[name="company_website"]').val()
						) {
							var website = $('[name="company_website"]').val();
							t.sellerData.links.website = website.toLowerCase();
							sellerParams['links'] = t.sellerData.links;
						}
						if (
							$('[name="company_phone_number"]').data('original') !=
							$('[name="company_phone_number"]').val()
						) {
							sellerParams['company_phone_number'] = $(
								'[name="company_phone_number"]',
							).val();
						} else {
							delete sellerParams['company_phone_number'];
						}
						if (
							($('[name="company_logo"]').data('original') === false &&
								$('[name="company_logo"]').attr('src').length > 0 &&
								$('[name="company_logo_new_ref"]').val().length > 0) ||
							($('[name="company_logo"]').data('original') &&
								$('[name="company_logo"]').data('original') !=
									$('[name="company_logo"]').attr('src'))
						) {
							sellerParams['company_logo_ref'] = $('[name="company_logo_new_ref"]').val();
						}
						if (
							($('[name="profile_picture"]').data('original') === false &&
								$('[name="profile_picture"]').attr('src').length > 0 &&
								$('[name="profile_picture_new_ref"]').val().length > 0) ||
							($('[name="profile_picture"]').data('original') &&
								$('[name="profile_picture"]').data('original') !=
									$('[name="profile_picture"]').attr('src'))
						) {
							sellerParams['chat_avatar_ref'] = $(
								'[name="profile_picture_new_ref"]',
							).val();
						}
						if (
							$('#contact_details_enabled').data('original') !==
							$('#contact_details_enabled').prop('checked')
						) {
							sellerParams['contact_details_enabled'] = $(
								'#contact_details_enabled',
							).prop('checked')
								? 1
								: 0;
						}
						if (
							$('#contact_buttons_enabled').data('original') !==
							$('#contact_buttons_enabled').prop('checked')
						) {
							sellerParams['contact_buttons_enabled'] = $(
								'#contact_buttons_enabled',
							).prop('checked')
								? 1
								: 0;
						}
						return sellerParams;
					},
					validateSellerParams: function (sellerParams) {
						var isValid = true;
						if (sellerParams.hasOwnProperty('description')) {
							if (
								sellerParams.description.trim().length < 30 &&
								sellerParams.description.trim().length != 0
							) {
								var desc = $('[name="company_description"]');
								addFormError(desc, _t('seller_settings_profile:about.company-name-section.errors.description-too-short'));
								isValid = false;
							} else {
								removeFormErrors($('[name="company_description"]').parent());
							}
						}
						if (sellerParams.hasOwnProperty('company')) {
							if (!sellerParams.company || sellerParams.company.trim().length === 0) {
								var name = $('[name="company_name"]');
								addFormError(name, _t('seller_settings_profile:about.company-name-section.errors.name-required'));
								isValid = false;
							} else {
								removeFormErrors($('[name="company_name"]').parent());
							}
						}
						if (sellerParams.hasOwnProperty('sales_email')) {
							if (
								sellerParams.sales_email.length === 0 ||
								!sellerParams.sales_email.match(/.*\@.*\./)
							) {
								addFormError(
									$('[name="company_email_address"]'),
									_t('seller_settings_profile:about.company-contact-details-section.errors.invalid-email')
								);
								isValid = false;
							} else {
								removeFormErrors($('[name="company_email_address"]'));
							}
						}
						if (sellerParams.hasOwnProperty('links')) {
							if (
								!sellerParams.links.hasOwnProperty('website') ||
								(sellerParams.links.website.length > 0 &&
									!sellerParams.links.website.match(
										/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
									))
							) {
								addFormError($('[name="company_website"]'), _t('seller_settings_profile:about.company-contact-details-section.errors.invalid-website'));
								isValid = false;
							} else {
								removeFormErrors($('[name="company_website"]'));
							}
						}
						return isValid;
					},
					saveUserInfo: function (defer) {
						var t = this;
						// no need to check because this group has only one member
						// so if theg group is  marked dirty, it is the only element that has changed
						var userParams = {
							name: $('[name="profile_name"]').val(),
						};
						if (userParams['name'].trim().length === 0) {
							var target = $('[name="profile_name"]');
							addFormError(target, _t('seller_settings_profile:about.name-profile-pic-section.errors.name-required'));
							scrollToFirstError();
							defer.reject();
							return;
						} else {
							removeFormErrors($('[name="profile_name"]'));
						}
						if (!$.isEmptyObject(userParams)) {
							Bark.api(
								'user/name',
								userParams,
								function (data) {
									$.each(userParams, function (k, v) {
										if (k === 'name') {
											$('[name="profile_name"]').data('original', v);
											$('.default-avatar[name="default_profile_picture"]').text(
												v.charAt(0),
											);
											removeFormErrors($('[name="profile_name"]').parent());
										}
									});
									formManager.dirty(t.formManagerHandleUser, false);
									updateCompletionPercentages(
										data.progress,
										'general-information',
										'profile_data',
									);
									defer.resolve();
								},
								function (error) {
									var errorData = handleErrors(error);
									var validationErrors = errorData['validation'];
									var errorArr = [];
									Object.keys(validationErrors).forEach(function (key) {
										var message = validationErrors[key][0];
										var element = $('[name="profile_name"]');
										addFormError(element, message);
									});
									defer.reject($('[name="profile_name"]'));
								},
								'PUT',
								Bark.apiVersionHeader('v2'),
							);
						}
					},
					saveSellerInfo: function (defer) {
						var t = this;
						var sellerParams = t.createSellerParams();
						if (!$.isEmptyObject(sellerParams)) {
							if (!t.validateSellerParams(sellerParams)) {
								defer.reject();
								scrollToFirstError();
								return;
							}
							Bark.api(
								'seller/profile',
								sellerParams,
								function (data) {
									// reset the data-original field for each one and remove errors
									$.each(sellerParams, function (k, v) {
										if (t.fieldMappings.hasOwnProperty(k)) {
											const fieldElement = t.getMappedFieldElement(t.fieldMappings[k]);
											let originalValue = t.fieldMappings[k].isImage
												? fieldElement.prop('src')
												: k === 'links'
													? v.website
													: v;
											fieldElement.data('original', originalValue);
											removeFormErrors(fieldElement.parent());
										}
										if (k === 'company_logo_ref') {
											t.updateHeaderAvatar();
										} else if (k === 'contact_details_enabled') {
											$('#contact_details_enabled').data(
												'original',
												$('#contact_details_enabled').prop('checked'),
											);
										} else if (k === 'contact_buttons_enabled') {
											$('#contact_buttons_enabled').data(
												'original',
												$('#contact_buttons_enabled').prop('checked'),
											);
										}
									});
									formManager.dirty(t.formManagerHandle, false);
									updateCompletionPercentages(
										data.progress,
										'general-information',
										'profile_data',
									);
									defer.resolve();
								},
								function (data) {
									var errorData = handleErrors(data);
									if (errorData.hasOwnProperty('validation')) {
										var validationErrors = errorData['validation'];
										Object.keys(validationErrors).forEach(function (key) {
											var message = validationErrors[key][0];
											if (t.fieldIsMapped(key)) {
												var element = t.getMappedFieldElement(t.fieldMappings[key]);

												if (element) {
													addFormError(element, message);
												}
											}
										});
									} else {
										if (errorData.hasOwnProperty('message')) {
											addFormError($('[name="company_phone_number"]'), errorData.message);
										} else {
											console.error(errorData);
										}
									}
									scrollToFirstError();
									defer.reject();
								},
								'PUT',
								Bark.apiVersionHeader('v2'),
							);
						} else {
							// nothing being sent, nothing to save
							formManager.dirty(t.formManagerHandle, false);
							defer.resolve();
						}
					},
					updateHeaderAvatar: function () {
						var headerAvatarHtml;
						// todo make this use handlebars or something so it doesnt get out of sync with the header
						if ($('.elite-pro').length) {
							headerAvatarHtml =
								'<div class="d-inline-flex text-white ml-3 mr-1 justify-content-center align-items-center">' +
								'<div class="elite-pro d-inline-flex">' +
								'<img class="img-fluid default-avatar elite-pro-border elite-pro-border-sm loaded" alt="" width="36" height="36" title="" src="' +
								$('[name="company_logo"]').prop('src') +
								'" data-was-processed="true">' +
								'<img class="elite-pro-icon elite-pro-icon-sm" src="https://d18jakcjgoan9.cloudfront.net/img/barkv2/material-icons/elite-pro.svg" alt="bark-elite-pro" height="18" width="18">' +
								'</div>' +
								'</div>';
						} else {
							headerAvatarHtml =
								'<div class="d-inline-flex text-white ml-3 mr-1 justify-content-center align-items-center">' +
								'<img class="img-fluid default-avatar loaded" alt="" width="36" height="36" title="" src="' +
								$('[name="company_logo"]').prop('src') +
								'" data-was-processed="true">' +
								'</div>';
						}

						$('#navbarDropdown').html(headerAvatarHtml);
					},
					addListeners: function () {
						$('#company_phone_number')
							.off('keyup.format')
							.on('keyup.format', function (e) {
								if (Bark.in_array(e.keyCode, [8, 37, 39])) {
									return false;
								}
								this.value = this.value.replace(/[^\d#()\[\]\-+ ]/, '');
							});
						// Trigger by default
						$('#company_phone_number').trigger('keyup.format');

						$('.general-information-container :input').on(
							'change.update, keyup.change',
							function () {
								if ($(this).data('field-type') === 'seller') {
									formManager.dirty(
										t.formManagerHandle,
										!$.isEmptyObject(t.createSellerParams()),
									);
								} else if ($(this).data('field-type') === 'user') {
									formManager.dirty(
										t.formManagerHandleUser,
										$(this).data('original') !== $(this).val(),
									);
								}
							},
						);

						$('#contact_details_enabled,#contact_buttons_enabled').on(
							'change.formlisten',
							function () {
								formManager.dirty(
									t.formManagerHandle,
									!$.isEmptyObject(t.createSellerParams()),
								);
							},
						);

						$('.company_logo_link').on('click', function (e) {
							e.preventDefault();
							$('.company_logo_file').trigger('click');
						});

						$('.company_logo_file').on('change', function (e) {
							e.preventDefault();
							var formData = new FormData();
							formData.append('image', $(this).get(0).files[0]);
							formData.append('type', 'logo');
							startSubmit($('.company_logo_link'));

							Bark.api(
								'seller/image',
								formData,
								function (data) {
									endSubmit($('.company_logo_link'));
									$('#company_logo')
										.show()
										.removeClass('d-none')
										.attr('src', data.preview);
									$('#company_logo_new_ref').val(data.ref);
									$('#company_logo_new_ref').val(data.ref);
									$('[name="default_company_logo"]').addClass('d-none');
									$('[name="default_company_logo"]').removeClass('d-inline-flex');
									formManager.dirty(t.formManagerHandle);
									removeFormErrors($('[name="company_logo_file"]').parent());
								},
								function (data) {
									endSubmit($('.company_logo_link'));
									var element = $('[name="company_logo_file"]');
									if (data.status == 0) {
										addFormError(element, _t('seller_settings_profile:about.company-name-section.errors.image-too-big'));
										return;
									}
									var errorData = handleErrors(data);
									if (
										!errorData.hasOwnProperty('validation') &&
										errorData.hasOwnProperty('message')
									) {
										var message = errorData.message;
										addFormError(element, message);
									} else {
										var validationErrors = errorData['validation'];
										Object.keys(validationErrors).forEach(function (key) {
											var message = validationErrors[key][0];
											addFormError(element, message);
										});
									}
								},
								'POST',
								Bark.apiVersionHeader('v2'),
								false,
								false,
								false,
							);
						});
						if (Bark.isMobile()) {
							$('#profile_picture_cam').hide();
						}
						$('.profile_picture_link').on('click', function (e) {
							e.preventDefault();
							$('.profile_picture_file').trigger('click');
						});
						$('.profile_picture_file').on('change', function (e) {
							e.preventDefault();
							var formData = new FormData();
							formData.append('image', $(this).get(0).files[0]);
							formData.append('type', 'chat-avatar');
							startSubmit($('.profile_picture_link'));
							Bark.api(
								'seller/image',
								formData,
								function (data) {
									endSubmit($('.profile_picture_link'));
									// set original img if it had one
									$('#profile_picture')
										.show()
										.removeClass('d-none')
										.attr('src', data.preview);
									$('[name="default_profile_picture"]')
										.addClass('d-none')
										.removeClass('d-inline-flex');
									$('#profile_picture_new_ref').val(data.ref);
									formManager.dirty(t.formManagerHandle);
									removeFormErrors($('[name="profile_picture_file"]').parent());
								},
								function (data) {
									var element = $('[name="profile_picture_file"]');
									endSubmit($('.profile_picture_link'));

									if (data.status == 0) {
										addFormError(element, _t('seller_settings_profile:about.name-profile-pic-section.errors.image-too-big'));
										return;
									}

									var errorData = handleErrors(data);
									if (
										!errorData.hasOwnProperty('validation') &&
										errorData.hasOwnProperty('message')
									) {
										var message = errorData.message;
										addFormError(element, message);
									} else {
										var validationErrors = errorData['validation'];
										Object.keys(validationErrors).forEach(function (key) {
											var message = validationErrors[key][0];
											addFormError(element, message);
										});
									}
								},
								'POST',
								Bark.apiVersionHeader('v2'),
								false,
								false,
								false,
							);
						});
						$('.profile_picture_cam').on('click', function (e) {
							e.preventDefault();
							try {
								if (navigator.mediaDevices === undefined) {
									navigator.mediaDevices = {};
								}
								if (navigator.mediaDevices.getUserMedia === undefined) {
									navigator.mediaDevices.getUserMedia = function (constraints) {
										// First get ahold of the legacy getUserMedia, if present
										var getUserMedia =
											navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
										// Some browsers just don't implement it - return a rejected promise with an error
										// to keep a consistent interface
										if (!getUserMedia) {
											return Promise.reject(
												new Error(_t('seller_settings_profile:about.name-profile-pic-section.errors.browser-error')),
											);
										}
										// Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
										return new Promise(function (resolve, reject) {
											getUserMedia.call(navigator, constraints, resolve, reject);
										});
									};
								}
								navigator.mediaDevices
									.getUserMedia({ video: { width: 300, height: 300 } })
									.then(function (stream) {
										if (Bark.isMobile()) {
											t.showNoCameraModal();
										}
										t.cameraVideoStream = stream;
										t.showCameraModal();
										// Elements for taking the snapshot
										var canvas = document.getElementById('camera-photo');
										t.cameraContext = canvas.getContext('2d');
										t.cameraVideo = document.getElementById('camera-video');
										try {
											if ('srcObject' in t.cameraVideo) {
												t.cameraVideo.srcObject = stream;
											} else {
												t.cameraVideo.src = window.URL.createObjectURL(stream);
											}
										} catch (err) {
											t.cameraVideo.src = stream;
										}
										t.cameraVideo.play();
									})
									.catch(function (err) {
										t.showNoCameraModal();
									});
							} catch (err) {
								t.showNoCameraModal();
							}
						});
					},
					handleCompanyInfoSection: function () {
						Bark.api(
							'sellerprofile/company-info',
							{},
							({ status, data }) => {
								if (status) {
									if (data.company_age !== '' && data.company_age >= 0) {
										let companyAgeEl = $('#company_age');
										companyAgeEl.val(data.company_age);
										if (companyAgeEl.data('original') === '') {
											companyAgeEl.data('original', companyAgeEl.val());
										}
									}
									if (data.company_size) {
										$('#company_size option[value="' + data.company_size + '"]').prop(
											'selected',
											true,
										);
										$('#company_size').data('original', data.company_size);
									}
									$('#company_age')
										.off('change.update, keyup.change')
										.on('change.update, keyup.change', function () {
											let currentVal = $(this).val().replace(/[^\d]/, '');
											$(this).val(currentVal);
											let original = $(this).data('original');
											formManager.dirty('company_info_section', original !== currentVal);
										});
									$('#company_size')
										.off('change.update, keyup.change')
										.on('change.update, keyup.change', function () {
											let currentVal = $(this).find('option:selected').val();
											let isDirty = $(this).data('original') !== currentVal;
											formManager.dirty('company_info_section', isDirty);
										});
								}
							},
							(err) => {
								console.error(err);
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
						formManager.register(
							'company_info_section',
							function (defer) {
								let payload = {};
								if (
									$('#company_size').find('option:selected').val() !==
									$('#company_size').data('original')
								) {
									removeFormErrors($('[name="company_size"]').parent());
									payload['company_size'] = $('#company_size')
										.find('option:selected')
										.val();
								}
								if ($('#company_age').val() !== $('#company_age').data('original')) {
									removeFormErrors($('[name="company_age"]').parent());
									payload['company_age'] = $('#company_age').val();
								}

								Bark.api(
									'sellerprofile/company-info',
									payload,
									function (data) {
										formManager.dirty('company_info_section', false);
										defer.resolve();
										updateCompletionPercentages(
											data.progress,
											'general-information',
											'profile_data',
										);
										$('#company_age').data('original', $('#company_age').val());
										$('#company_size').data(
											'original',
											$('#company_size').find('option:selected').val(),
										);
									},
									function (err) {
										let errorData = handleErrors(err);
										if (errorData.hasOwnProperty('validation')) {
											let validationErrors = errorData['validation'];
											let errorArr = [];
											Object.keys(validationErrors).forEach(function (key) {
												let message = validationErrors[key][0];
												let element = '';
												if (key === 'company_size') {
													element = $('[name="company_size"]');
												} else if (key === 'company_age') {
													element = $('[name="company_age"]');
													message =
                                                        _t('seller_settings_profile:about.about-company-section.years-in-business-input.description');
												}
												if (element) {
													addFormError(element, message);
												}
											});
										} else {
											if (errorData.hasOwnProperty('message')) {
												console.error(errorData, 'co-inf');
											}
											addFormError($('[name="company_age"]'), _t('seller_settings_profile:about.about-company-section.errors.generic'));
											addFormError($('[name="company_size"]'), _t('seller_settings_profile:about.about-company-section.errors.generic'));
										}
										scrollToFirstError();
										defer.reject();
									},
									'POST',
									Bark.apiVersionHeader('v2'),
								);
							},
							function () {
								formManager.dirty('company_info_section', false);
								$('[data-cancellable]').each(function (i) {
									removeFormErrors($('[name="company_size"]').parent());
									removeFormErrors($('[name="company_age"]').parent());
									$(this).val($(this).data('original'));
								});
							},
						);
					},
					handleLocationSection: function () {
						const profileLocationsAPI = ProfileLocationsAPI();
						const googlePlacesMapManager = GooglePlacesMapManager();

						const mapDomElements = {
							containerId: 'company_address_map',
							addressInputId: 'company_address',
							errorContainerId: 'map_errors',
						};
						const oldLocation = oldStyleCompanyLocation;

						const $autoComplete = $(`#${mapDomElements.addressInputId}`);
						const $oldStyleCompanyLocationInput = $(`.js-old-location`);
						const $newCompanyLocationInput = $(`.js-new-location`);
						const $isPrivate = $(`#company_address_is_private`);
						const $fakeMapContainer = $('#fakemap_container');
						const $primaryLocationId = $('#primary_location_id');
						const $locationUnavailableReason = $(
							'#company_address_is_unavailable_reason',
						);
						const $locationDisplayStringContainer = $(
							'#js-location-display-string-container',
						);

						const state = {
							primaryLocationId: '',
							shouldShowLegacyLocation: false,
							isSuggestion: false,
							shouldSaveLocation: true,
							locationString: $autoComplete.val(),
							isPrivate: false,
						};

						const initialState = {
							// Set on load, used for comparing whether form is dirty or clean
						};

						const mapOptions = {
							gestureHandling: 'none',
							clickableIcons: false,
							draggableCursor: 'default',
							draggingCursor: 'default',
						};

						// Initialise map manager. Set to default location view (whole country)
						let defaultMap = googlePlacesMapManager.getBestDefaultMapViewForCountry(
							window.Bark.LOCALE.iso2c,
						);
						googlePlacesMapManager.setDefaultStateValue(defaultMap, mapOptions);
						googlePlacesMapManager.initMap(
							mapDomElements,
							window.Bark.LOCALE.iso2c,
							mapOptions,
						);
						let locations,
							primaryLocation,
							settings = null;

						/**
						 * populateFormWithLocationData -- populates the map, autocomplete, and the 'is_private' checkbox
						 * @param {Object} data -- response from the API
						 */
						const populateFormWithLocationData = (data) => {
							locations = data?.data;
							if (locations && locations.length > 0) {
								//Even though we only have one location, allow for future locations.
								locations.forEach((location) => {
									if (
										location.type === 'seller_location' &&
										location.attributes.priority === 0
									) {
										primaryLocation = location;
									}
								});

								if (!primaryLocation) {
									console.warn('We had locations, but no primary location for seller.');
									bugsnagClient.notify(
										new Error('We had locations, but no primary location for seller.'),
									);
								}
							} else {
								// If no locations, and has an old location:
								if (oldLocation) {
									$oldStyleCompanyLocationInput.prop('value', oldLocation);
									$oldStyleCompanyLocationInput.prop('disabled', true);
									state.shouldShowLegacyLocation = true;
									showLegacyLocation();
									showPrivateCheckbox();
								} else {
									state.shouldShowLegacyLocation = false;
								}
							}

							if (primaryLocation) {
								/**
								 * Initialise the map
								 */
								let mapState = {
									center: {
										lat: Number(primaryLocation.attributes.lat),
										lng: Number(primaryLocation.attributes.lng),
									},
									zoom: 14,
								};

								let placeState = {
									place_id: primaryLocation.attributes.google_places_id,
								};

								// Set initial state. Used later to check whether form is truly dirty.
								initialState.hasPrimaryLocation = true;
								initialState.placeId = placeState.place_id;
								initialState.mapState = mapState;
								initialState.primaryLocationId = primaryLocation.id;
								initialState.locationString = primaryLocation.attributes.location_string;
								initialState.isPrivate = primaryLocation.attributes.location_is_private;

								googlePlacesMapManager.setMapToState(mapState);
								googlePlacesMapManager.setMarker(mapState.center);
								state.locationString = primaryLocation.attributes.location_string;
								$autoComplete.val(state.locationString);
								state.primaryLocationId = primaryLocation.id;
								$primaryLocationId.val(state.primaryLocationId);
								setIsPrivateState(primaryLocation.attributes.location_is_private);
								googlePlacesMapManager.setPlaceState(placeState);
								const newCompanyLocationVal =
									primaryLocation.attributes?.location_display_string;
								if (primaryLocation.attributes.location_is_suggestion) {
									state.isSuggestion = true;
									handleSuggestedLocation();
								}
								if (newCompanyLocationVal) {
									$newCompanyLocationInput.val(newCompanyLocationVal);
									showLocationDisplayString();
									showPrivateCheckbox();
									if (state.isSuggestion) {
										disablePrivateCheckbox();
									} else {
										enablePrivateCheckbox();
									}
								} else {
									$newCompanyLocationInput.val();
									hideLocationDisplayString();
									hidePrivateCheckbox();
									disablePrivateCheckbox();
								}
							}
						};

						const handleSuggestedLocation = () => {
							showSuggestionInfoBox();
							bindSuggestionInfoBoxListners();
						};

						const showSuggestionInfoBox = () => {
							$('.js-suggestion-info-box').removeClass('d-none');
						};

						const hideSuggestionInfoBox = () => {
							$('.js-suggestion-info-box').addClass('d-none');
						};

						const bindSuggestionInfoBoxListners = () => {
							$('.js-confirm-suggested-location').on('click', function (e) {
								e.preventDefault();
								state.isSuggestion = false;
								formManager.dirty('profile-location', true);
								hideSuggestionInfoBox();
								enablePrivateCheckbox();
								uncheckPrivateCheckbox();
							});

							$('.js-edit-suggested-location').on('click', function (e) {
								e.preventDefault();
								state.isSuggestion = false;
								$autoComplete.val('');
								googlePlacesMapManager.setPlaceState(null);
								$newCompanyLocationInput.val('');
								state.locationString = '';
								$autoComplete.focus();
								hideSuggestionInfoBox();
								uncheckPrivateCheckbox();
								disablePrivateCheckbox();
								hideLocationDisplayString();
							});
						};

						/**
						 * populateFormWithLocationSettings -- populate the location_is_unavailable dropdown
						 * @param {Object} data -- response from the API
						 */
						const populateFormWithLocationSettings = (data) => {
							let success = data?.success;
							let settings = data?.data;

							if (!success) {
								bugsnagClient.notify(new Error('Location settings returned failure'));
								return;
							}

							if (!settings) {
								hideAddALocationLink();
								return;
							}

							if (success && settings && settings?.attributes) {
								let { location_is_unavailable, location_is_unavailable_reason } =
									settings.attributes;
								initialState.locationIsUnavailable = location_is_unavailable;
								initialState.locationIsUnavailableReason = location_is_unavailable_reason;
								if (location_is_unavailable) {
									hideMap();
								} else {
									showMap();
								}
								if (location_is_unavailable_reason) {
									hideMap();
									state.shouldShowLegacyLocation = false;
									hideLegacyLocation();
									$(
										'#company_address_is_unavailable_reason option[value="' +
											location_is_unavailable_reason +
											'"]',
									).prop('selected', true);
									$locationUnavailableReason.data(
										'original',
										location_is_unavailable_reason,
									);
								} else {
									showMap();
									showLegacyLocation();
									$(
										'#company_address_is_unavailable_reason option[value="disabled-default"]',
									).prop('selected', true);
									$locationUnavailableReason.data(
										'original',
										location_is_unavailable_reason,
									);
								}
							}
						};

						const setIsPrivateState = (isPrivate) => {
							$isPrivate.prop('checked', isPrivate);
							state.isPrivate = isPrivate;
						};

						const getLocationSettingsDataForAPI = () => {
							let location_is_unavailable, location_is_unavailable_reason;
							location_is_unavailable_reason = $locationUnavailableReason.val();
							if (
								location_is_unavailable_reason &&
								location_is_unavailable_reason !== 'disabled-default'
							) {
								location_is_unavailable = true;
							} else {
								location_is_unavailable = false;
								location_is_unavailable_reason = null;
							}
							return {
								location_is_unavailable,
								location_is_unavailable_reason,
							};
						};

						const hideMap = () => {
							$(`#${mapDomElements.containerId}`).addClass('d-none');
							$('#autocomplete_label').addClass('d-none');
							$('#company_address_row').addClass('d-none');
							$('#location_header_section').removeClass('mb-3').addClass('mb-0');
							$autoComplete.addClass('d-none');
							$fakeMapContainer.removeClass('d-none');
							hideLocationDisplayString();
							disablePrivateCheckbox();
							hidePrivateCheckbox();
							showAddALocationLink();
						};

						const showMap = () => {
							$fakeMapContainer.addClass('d-none');
							$autoComplete.removeClass('d-none');
							$('#company_address_row').removeClass('d-none');
							$('#location_header_section').addClass('mb-3').removeClass('mb-0');
							$(`#${mapDomElements.containerId}`).removeClass('d-none');
							$('#autocomplete_label').removeClass('d-none');
							if (!state.isSuggestion) {
								enablePrivateCheckbox();
							}
							showPrivateCheckbox();
							showLocationDisplayString();
							hideAddALocationLink();
						};

						const hideAddALocationLink = () => {
							$('.js-enable-map').hide();
						};

						const showAddALocationLink = () => {
							$('.js-enable-map').show();
						};

						const hideLegacyLocation = () => {
							$('.js-show-if-old-location').addClass('d-none');
							$('.js-hide-if-old-location').removeClass('d-none');
						};

						const showLegacyLocation = () => {
							if (state.shouldShowLegacyLocation) {
								$('.js-show-if-old-location').removeClass('d-none');
								$('.js-hide-if-old-location').addClass('d-none');
								hideLocationDisplayString();
							}
						};

						const hidePrivateCheckbox = () => {
							$('.location-private-container').toggleClass('d-none', true);
						};

						const showPrivateCheckbox = () => {
							$('.location-private-container').toggleClass('d-none', false);
						};

						const disablePrivateCheckbox = () => {
							$('#company_address_is_private')
								.prop('disabled', true)
								.attr('checked', false);
							$('#description_is_private').show();
						};

						const enablePrivateCheckbox = () => {
							$('#company_address_is_private').prop('disabled', false);
							$('#description_is_private').hide();
						};

						const uncheckPrivateCheckbox = () => {
							$('#company_address_is_private').prop('checked', false);
						};

						const registerHandlers = () => {
							// Cheeky click handler binding
							$('.js-enable-map')
								.off('click')
								.on('click', function () {
									$(
										'#company_address_is_unavailable_reason option[value="disabled-default"]',
									).prop('selected', true);
									showMap();
									state.shouldShowLegacyLocation = false;
									hideLegacyLocation();
									if (state.isSuggestion) {
										showSuggestionInfoBox();
									} else {
										$autoComplete.focus();
									}
									state.shouldSaveLocation = true;
								});

							// Cheeky change binding
							$('#company_address_is_unavailable_reason')
								.off('change')
								.on('change', function () {
									let reason = $('#company_address_is_unavailable_reason').val();
									const hasChanged = reason !== initialState.locationIsUnavailableReason;
									const isNotDefaultReason = reason !== 'disabled-default';
									if (hasChanged) {
										formManager.dirty('profile-location', true);
									}
									state.shouldShowLegacyLocation = false;
									hideLegacyLocation();
									if (isNotDefaultReason) {
										hideMap();
										if (hasChanged) {
											state.shouldSaveLocation = false;
											if (state.isSuggestion) {
												hideSuggestionInfoBox();
											}
										}
									} else {
										showMap();
										state.shouldSaveLocation = false;
									}
								});

							let autocompleteObj = googlePlacesMapManager.getAutocompleteObject();
							if (autocompleteObj) {
								autocompleteObj.addListener('place_changed', () => {
									let place = autocompleteObj.getPlace();
									state.locationString = $autoComplete.val();
									if (!place.geometry || !place.geometry.location) {
										// No place, or invalid place
										disablePrivateCheckbox();
										formManager.dirty('profile-location', false);
									} else {
										enablePrivateCheckbox();
										setLocationDisplayString(place);
										hideLegacyLocation();
										state.shouldSaveLocation = true;
										formManager.dirty('profile-location', true);
									}
								});
							}

							$primaryLocationId.on('change', () => {
								formManager.dirty('profile-location', true);
							});

							$isPrivate.on('change', () => {
								if ($isPrivate.is(':checked')) {
									state.isPrivate = true;
									$('#description_is_private').show();
								} else {
									state.isPrivate = false;
									$('#description_is_private').hide();
								}
								if (state.isPrivate !== initialState.isPrivate) {
									formManager.dirty('profile-location', true);
								}
							});
						};

						const showLocationDisplayString = () => {
							if ($newCompanyLocationInput.val() !== '') {
								$locationDisplayStringContainer.removeClass('d-none');
							}
						};

						const hideLocationDisplayString = () => {
							$locationDisplayStringContainer.addClass('d-none');
						};

						const setLocationDisplayString = (place) => {
							let locationDisplayString = '';
							if (window.Bark.LOCALE.iso2c !== 'gb') {
								locationDisplayString = state.locationString;
							} else {
								let { address_components } = place;
								let locationObj = {};
								address_components.forEach(function (component) {
									component.types.forEach(function (address_type) {
										locationObj[address_type] = component.short_name;
									});
								});
								if (locationObj?.administrative_area_level_1) {
									locationDisplayString = locationObj?.administrative_area_level_1;
								}
								if (locationObj?.administrative_area_level_2) {
									locationDisplayString = locationObj?.administrative_area_level_2;
								}
								if (locationObj?.route) {
									locationDisplayString = locationObj?.route;
								}
								if (locationObj?.postal_code && locationObj?.postal_town) {
									locationDisplayString =
										locationObj?.postal_code.split(' ')[0] +
										', ' +
										locationObj?.postal_town;
								}
								if (locationObj?.locality) {
									locationDisplayString = locationObj?.locality;
								}
								if (locationObj?.neighbourhood) {
									locationDisplayString = locationObj?.neighbourhood;
								}
							}
							if (locationDisplayString !== '') {
								$newCompanyLocationInput.prop('value', locationDisplayString);
								$newCompanyLocationInput.prop('disabled', true);
								showLocationDisplayString();
							} else {
								$newCompanyLocationInput.prop('value', '');
								hideLocationDisplayString();
							}
						};
						const registerSave = () => {
							formManager.register(
								'profile-location',
								(defer) => {
									let saveLocationDefer = $.Deferred();
									let saveLocationSettingsDefer = $.Deferred();
									let locationData = googlePlacesMapManager.getMapAndPlaceState();
									let locationSettingsData = getLocationSettingsDataForAPI();
									let location_is_private = $isPrivate.prop('checked');
									let shouldSaveLocation = false;

									if (
										state.shouldSaveLocation &&
										locationData?.place_id &&
										locationData?.center
									) {
										// This is to make sure we actually have some location data to save
										// Otherwise, just save the location settings
										shouldSaveLocation = true;
									}

									let data = {
										locations: [
											{
												priority: 0, //Always zero for primary location.
												label: '',
												lat: locationData?.center?.lat,
												lng: locationData?.center?.lng,
												google_places_id: locationData?.place_id,
												location_string: state.locationString,
												location_data: JSON.stringify(locationData?.address_components),
												location_is_private,
												source: 'google_places_api',
											},
										],
									};

									if (state.primaryLocationId) {
										// Save updates onto the primary location
										data.locationId = state.primaryLocationId;
										if (shouldSaveLocation) {
											profileLocationsAPI.saveLocation(
												state.primaryLocationId,
												data.locations[0],
												(res) => {
													saveLocationsSuccessHandler(res);
												},
												() => {
													saveLocationDefer.reject();
												},
											);
										} else {
											saveLocationDefer.resolve();
										}
										profileLocationsAPI.saveLocationSettings(
											locationSettingsData,
											(res) => {
												saveLocationSettingsSuccessHandler(res);
											},
											() => {
												saveLocationSettingsDefer.reject();
											},
										);
									} else {
										// Primary location not defined. Create.
										if (shouldSaveLocation) {
											state.shouldShowLegacyLocation = false;
											hideLegacyLocation();
											profileLocationsAPI.saveLocations(
												data,
												(res) => {
													saveLocationsSuccessHandler(res);
												},
												() => {
													saveLocationDefer.reject();
												},
											);
										}
										profileLocationsAPI.saveLocationSettings(
											locationSettingsData,
											(res) => {
												saveLocationSettingsSuccessHandler(res);
											},
											() => {
												saveLocationSettingsDefer.reject();
											},
										);
									}

									function saveLocationsSuccessHandler(response) {
										if (response.meta.success === true) {
											if (response.data.type !== 'seller_location') {
												populateFormWithLocationData(response);
											} // Only update when we have an array of locations, not just one location
											if (response.data.id && response.data.attributes.priority === 0) {
												state.primaryLocationId = response.data.id;
											} // Update the old ID
											if (state.isSuggestion) {
												hideSuggestionInfoBox();
												state.isSuggestion = false; // if we have saved a location successfully, its no longer a suggestion
											}
											updateCompletionPercentages(
												response.meta.progress,
												'general-information',
												'profile_data',
											);
											saveLocationDefer.resolve();
										} else {
											saveLocationDefer.reject();
										}
									}

									function saveLocationSettingsSuccessHandler(response) {
										if (response.success === true) {
											updateCompletionPercentages(
												response.progress,
												'general-information',
												'profile_data',
											);
											saveLocationSettingsDefer.resolve();
										} else {
											saveLocationSettingsDefer.reject();
										}
									}

									$.when(saveLocationDefer).then(
										() => {
											defer.resolve();
											initialState.isPrivate = location_is_private;
											formManager.dirty('profile-location', false);
										},
										() => {
											defer.reject();
										},
									);

									$.when(saveLocationSettingsDefer).then(
										() => {
											defer.resolve();
											formManager.dirty('profile-location', false);
										},
										() => {
											defer.reject();
										},
									);
								},
								(err) => {
									formManager.dirty('profile-location', false);
								},
							);
						};

						// Get data from API
						profileLocationsAPI.getLocations((data) => {
							populateFormWithLocationData(data);
							profileLocationsAPI.getLocationSettings(
								populateFormWithLocationSettings,
								false,
							);
						}, false);
						registerSave();
						registerHandlers();
					},

					handleExperiments: function () {
						const init = function () {
							// no experiments yet
						};
						const checkIfInExp = function (target) {
							return (
								$('#' + target + '.esdh').length > 0 &&
								$('#' + target + '.esdh').data('variant') > 0
							);
						};
						init();
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function Reviews() {
				var instanceVars = {
					reviewItemTemplate: Handlebars.compile(
						document.getElementById('review-item-template').innerHTML,
					),
					reportReviewTemplate: Handlebars.compile(
						document.getElementById('report-review-template').innerHTML,
					),
					respondReviewTemplate: Handlebars.compile(
						document.getElementById('respond-review-template').innerHTML,
					),
					reviewPaginatorTemplate: Handlebars.compile(
						document.getElementById('review-paginator-template').innerHTML,
					),
					reviewSourceItemTemplate: Handlebars.compile(
						document.getElementById('review-sources-item-template').innerHTML,
					),
					bidvineReviewImportModalTemplate: Handlebars.compile(
						document.getElementById('bidvine-reviews-import-modal-template').innerHTML,
					),
					bidvineReviewDismissModalTemplate: Handlebars.compile(
						document.getElementById('bidvine-reviews-dismiss-modal-template').innerHTML,
					),
					externalSources: [],
					changedReviewSourceIDs: {},
					reviewSourcesHandle: 'review-sources',
					setCounts: true,
					callRegisters: {
						bark_reviews: $.Deferred(),
						// google_reviews: $.Deferred(),
						// facebook_reviews: $.Deferred(),
						all_reviews: $.Deferred(),
						external_sources: $.Deferred(),
					},
					initialise: function () {
						var t = this;
						var sortType = 'review';
						if (QS.hasKey('review-sort')) {
							sortType = QS.getValue('review-sort') === 'added' ? 'import' : 'review';
						}
						t.setReviewSort(sortType);
						t.getReviewsSummary();
						t.getReviews('bark');
						t.getReviewSources();
						// t.getReviews('google');
						// t.getReviews('facebook');
						$.when(t.callRegisters['external_sources']).then(function () {
							t.getReviews('all');
							t.addListeners();
							t.setCounts = false;
						});
						// init popovers
						$('[data-toggle="popover"]').popover();
					},
					resolveRegister: function (registerName) {
						if (typeof this.callRegisters[registerName] !== 'undefined') {
							this.callRegisters[registerName].resolve();
						}
					},
					setReviewSort: function (sortType) {
						if (typeof sortType === 'undefined') {
							sortType = 'review';
						}
						var newOrder = sortType === 'import' ? 'import' : 'review';
						$('#review-sort-order').val(newOrder);
						$('.all-reviews').data('order', newOrder);
					},
					toggleReviewSource: function (sourceId, visible) {
						var t = this;
						if (typeof visible === 'undefined') {
							visible = 'unset';
						}
						var sourceIndex = t.externalSources.findIndex(function (el) {
							return el.id === sourceId;
						});
						if (t.externalSources[sourceIndex]) {
							t.externalSources[sourceIndex].visible =
								visible === 'unset' ? !t.externalSources[sourceIndex].visible : visible;
						}
					},
					isSourceHidden: function (sourceName) {
						var t = this;
						var sourceIndex = t.externalSources.findIndex(function (el) {
							return el.name === sourceName;
						});
						return t.externalSources[sourceIndex]
							? !t.externalSources[sourceIndex].visible
							: true;
					},
					getReviewSourceNameFromId: function (sourceId) {
						var t = this;
						var sourceIndex = t.externalSources.findIndex(function (el) {
							return el.id === sourceId;
						});
						return t.externalSources[sourceIndex]
							? t.externalSources[sourceIndex]['name']
							: 'generic';
					},
					getSourceIconName: function (sourceName) {
						var icons_that_exist = [
							'rs_facebook',
							'rs_foursquare',
							'rs_homeadvisor',
							'rs_houzz',
							'rs_weddingwire',
							'rs_yell',
							'rs_yelp',
							'facebook_com',
							'facebook',
							'facebook_graph_api',
							'maps_googleapis_com',
							'google',
						];
						if (sourceName === 'rs_maps') {
							sourceName = 'google';
						}
						var review_icon_path =
							'https://d18jakcjgoan9.cloudfront.net/img/barkv2/third-party-icons/';
						var found_icon = icons_that_exist.indexOf(
							sourceName.trim().replace(/[\. ,:-]+/g, '_'),
						);
						if (found_icon >= 0) {
							review_icon_path += icons_that_exist[found_icon] + '-review-icon.png';
						} else {
							review_icon_path += 'generic-review-icon.png';
						}
						return review_icon_path;
					},
					getRandomAvatarColor: function () {
						// this is taken from _variables.scss just grabbed some hexcodes
						var colors = [
							'#2D7AF1',
							'#fa9750',
							'#f7bf53',
							'#ef6277',
							'#ef6277',
							'#F9C665',
							'#E6736C',
							'#E33E6E',
							'#8C2963',
							'#8CD2DE',
							'#00B0F0',
							'#155FA0',
							'#26848E',
							'#47BF9C',
							'#C1DC17',
							'#B2A0F7',
							'#AF42FF',
						];
						return colors[Math.floor(Math.random() * colors.length)];
					},
					parseContentForReviews: function (str) {
						if (!str || str.trim() === 'null' || str.trim() === '') {
							return false;
						} else {
							return nl2br(str.trim());
						}
					},
					populateReviews: function (provider, total, currentPage, lastPage, reviews) {
						var reviewsContainer = $('.' + provider + '-reviews .reviews-container');
						if (!total) {
							$('.' + provider + '-reviews').addClass('no-reviews');
							$('.' + provider + '-reviews').removeClass('has-reviews');
						} else {
							var newReviews = [];
							var t = this;
							reviews.forEach(function (review) {
								if (typeof review.response === 'undefined') {
									review.response = false;
								}
								newReviews.push(
									t.reviewItemTemplate({
										id: review.id,
										type: provider,
										type_bark: provider == 'bark',
										type_google: provider == 'google',
										type_facebook: provider == 'facebook',
										type_other: review.hasOwnProperty('review_source')
											? review.review_source
											: false,
										type_other_icon: review.hasOwnProperty('review_source')
											? t.getSourceIconName(review.review_source)
											: false,
										source_is_hidden: review.hasOwnProperty('review_source')
											? t.isSourceHidden(review.review_source)
											: false,
										reported: review.reported,
										reviewer: review.review_reviewer
											? review.review_reviewer
											: 'Anonymous',
										response: review.response,
										date: review.review_date
											? moment(review.review_date, 'YYYY-MM-DD HH:mm:SS').format(
												'DD MMM YYYY',
											  )
											: false,
										score: parseInt(
											(review.review_score / review.review_score_out_of) * 10,
										),
										message: t.parseContentForReviews(review.review_desc),
										first_initial: review.review_reviewer
											? review.review_reviewer.charAt(0).toUpperCase()
											: 'A',
										avatar_color: t.getRandomAvatarColor(),
									}),
								);
							});
							reviewsContainer.find('.review-items').empty().append(newReviews.join(''));
							new PaginationManager().output(
								$(reviewsContainer.find('.review-pagination')),
								lastPage,
								currentPage,
								function (page) {
									if (!reviewsContainer.hasClass('waiting')) {
										reviewsContainer.addClass('waiting');
										t.getReviews(provider, page);
									}
								},
								provider + '-review-pagination',
							);
							$('.' + provider + '-reviews').removeClass('no-reviews');
							$('.' + provider + '-reviews').addClass('has-reviews');
							reviewsContainer.removeClass('waiting');
						}
						$('.' + provider + '-reviews').removeClass('waiting');
					},
					populateReviewSources: function () {
						var t = this;
						var reviewSourcesContainer = $('.review-sources-container .review-sources');
						if (t.externalSources.length > 0) {
							var newSources = [];
							t.externalSources.forEach(function (source) {
								newSources.push(
									t.reviewSourceItemTemplate({
										nicename: source.friendly_name
											? source.friendly_name
											: source.name.charAt(0).toUpperCase() + source.name.slice(1),
										visible: source.visible,
										name: source.name,
										id: source.id,
									}),
								);
							});
							$('#review-sources-list-container')
								.find('.source-items')
								.empty()
								.append(newSources.join(''));
							$('.source-items').toggleClass('show-fade', newSources.length > 3);
							reviewSourcesContainer.parent().addClass('has-reviews');
							reviewSourcesContainer.parent().removeClass('no-reviews');
						} else {
							reviewSourcesContainer.parent().addClass('no-reviews');
							reviewSourcesContainer.parent().removeClass('has-reviews');
						}
						$('.review-sources').removeClass('waiting');
					},
					removeFormErrors: function (parentElement) {
						parentElement.find('.is-invalid').removeClass('is-invalid');
						parentElement.find('.invalid-feedback').val('').css({ display: 'none' });
					},
					showFormErrors: function () {
						$('.review-invite-container .invalid-feedback').css({ display: 'block' });
					},
					// api calls
					inviteForReview: function () {
						var t = this;
						startSubmit($('.review-invite-link'));
						t.removeFormErrors($('.review-invite-container'));
						var emailString = $('[name="review-invite-emails"]:visible').val();
						if (emailString.length == 0) {
							addFormError(
								$('[name="review-invite-emails"]'),
								_t('seller_settings_profile:invite-reviews.error.enter-emails'),
							);
							t.showFormErrors();
							endSubmit($('.review-invite-link'));
							return false;
						}
						var emailArray = emailString.split(',').map(function (item) {
							return item.trim();
						});
						Bark.api(
							'seller/review/invite',
							{
								emails: emailArray,
							},
							function (data) {
								endSubmit($('.review-invite-link'), _t('seller_settings_profile:invite-reviews.success'));
								$('[name="review-invite-emails"]:visible').val('');
							},
							function (error) {
								if (error.status === 422) {
									var errorMessages = [];
									var validationMessages = error.responseJSON.error.errors;
									for (var key in validationMessages) {
										// skip loop if the property is from prototype
										if (!validationMessages.hasOwnProperty(key)) continue;

										var obj = validationMessages[key];
										for (var prop in obj) {
											// skip loop if the property is from prototype
											if (!obj.hasOwnProperty(prop)) continue;

											var emailIndex = parseInt(key.replace('emails.', ''));
											errorMessages.push(
                                                _t('seller_settings_profile:invite-reviews.error.email-not-valid', {
                                                    'email': emailArray[emailIndex]
                                                })
											);
										}
									}
									addFormError($('[name="review-invite-emails"]'), errorMessages.pop());
									t.showFormErrors();
									endSubmit($('.review-invite-link'));
								}
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					setReviewCount: function (provider, count) {
						const text = _t('seller_settings_profile:reviews-section.review-count', {count})
						$('.' + provider + '-review-count').text(text);
					},
					setReviewsError: function (provider) {
						$('.' + provider + '-reviews-link').addClass('d-none');
						$('.' + provider + '-reviews')
							.addClass('has-error')
							.removeClass('waiting');
					},
					getReviewSources: function () {
						var t = this;
						// API call to fetch the sources
						Bark.api(
							'seller/reviews/providers/',
							{},
							function (data) {
								if (data.status && data.data.items.length > 0) {
									t.externalSources = data.data.items;
									t.externalSources.forEach(function (source) {
										if (source.name.indexOf('rs_') === -1) {
											source.name = source.name
												.replace('.com', '')
												.replace('maps', '')
												.replace('apis', '')
												.replace('.', ' ');
										}
										source.name = source.name.trim();
									});
									t.populateReviewSources();
									t.resolveRegister('external_sources');
									$('.review-sources').parent().removeClass('no-reviews');
									$('.review-sources').parent().addClass('has-reviews');
									formManager.register(
										t.reviewSourcesHandle,
										function (defer) {
											t.saveReviewSourceSettings(defer);
										},
										function () {
											Object.keys(t.changedReviewSourceIDs).forEach(function (sourceId) {
												var sourceCheckboxEl = $(
													".review-source-visibility[data-review-source='" +
														sourceId +
														"']",
												);
												sourceCheckboxEl.prop(
													'checked',
													!t.changedReviewSourceIDs[sourceId],
												);
											});
											t.changedReviewSourceIDs = {};
											formManager.dirty(t.reviewSourcesHandle, false);
										},
									);
								} else {
									// error handling  -- no review sources.
									$('.review-sources').parent().removeClass('has-reviews');
									$('.review-sources').parent().addClass('no-reviews');
									t.resolveRegister('external_sources');
								}
							},
							function (err) {
								$('.review-sources').parent().removeClass('has-reviews');
								$('.review-sources').parent().addClass('no-reviews');
								t.resolveRegister('external_sources');
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					getReviews: function (provider, page) {
						if (typeof page === 'undefined') {
							page = 1;
						}
						this.setCounts = page < 2 && this.setCounts;
						if (provider === 'bark') {
							this.getBarkReviews(page, this.setCounts);
						} else {
							this.getExternalReviews(provider, page, this.setCounts);
						}
					},
					getReviewsSummary: function () {
						var t = this;

						Bark.api(
							'seller/reviews/summary/',
							{},
							function (data) {
								var score = data.data.score;
								var reviewsnum = data.data.total_reviews;
								var bidvinereviewsnum = data.data?.bidvine_reviews_count;
								var bidvine_reviews_dismissed = data.data?.bidvine_reviews_dismissed;
								var breakdown = data.data.breakdown;

								t.setReviewCount('bark', breakdown.bark);
								t.setReviewCount('all', breakdown.external);
								$('#sp_star_count')
									.attr('class', 'd-flex')
									.addClass('star-count-' + score * 2);
								$('.overall-rating .review-score', '.review-score').text(score + '/5');
								$('.review-score').text(score + '/5');
								$('.bidvine-reviews-total-int').data(
									'bidvine-reviews-count',
									bidvinereviewsnum,
								);
								$('.bidvine-reviews-total-int').data(
									'bidvine-reviews-dismiss',
									bidvine_reviews_dismissed,
								);
								$('.review-count #reviews-total-int').text(reviewsnum);
								if (!bidvine_reviews_dismissed && bidvinereviewsnum > 0) {
									$('.bidvine-reviews').removeClass('waiting');
								}
							},
							function (data) {},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					getExternalReviews: function (provider, page) {
						var t = this;
						var order = $('.all-reviews').data('order');
						$('.all-reviews').addClass('waiting');
						Bark.api(
							'seller/reviews/external/' + page,
							{
								order: order,
							},
							function (data) {
								var total = data.data.total;
								var reviews = data.data.items;
								var currentPage = data.data.current_page;
								var lastPage = data.data.last_page;
								for (var i = 0; i < reviews.length; i++) {
									reviews[i]['review_source'] = t.getReviewSourceNameFromId(
										reviews[i]['external_data_source_id'],
									);
								}
								t.populateReviews(provider, total, currentPage, lastPage, reviews);
								t.resolveRegister(provider + '_reviews');
								$('.all-reviews').removeClass('waiting');
							},
							function (data) {
								t.setReviewsError(provider);
								t.resolveRegister(provider + '_reviews');
								$('.all-reviews').removeClass('waiting');
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					getBarkReviews: function (page) {
						var t = this;
						Bark.api(
							'seller/reviews/' + page,
							{},
							function (data) {
								var total = data.data.total;
								var currentPage = data.data.current_page;
								var lastPage = data.data.last_page;
								var reviews = data.data.items;
								var parsedReviews = [];
								reviews.forEach(function (review) {
									parsedReviews.push({
										id: review.id,
										reported: review.reported,
										review_reviewer: review.name,
										review_date: review.created,
										review_score: review.score,
										review_score_out_of: 5,
										review_desc: review.text,
										response: review.response,
									});
								});
								t.populateReviews('bark', total, currentPage, lastPage, parsedReviews);
								t.resolveRegister('bark_reviews');
							},
							function (data) {
								t.setReviewsError('bark');
								t.resolveRegister('bark_reviews');
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					reportExternalReview: function (provider, reviewId, reportType, notes) {
						var t = this;
						Bark.api(
							'/seller/ext-review/report',
							{
								rid: reviewId,
								type: reportType,
								notes: notes,
							},
							function (data) {
								$('#' + provider + '-review-' + reviewId)
									.find('.review-links')
									.addClass('reported');
								modalManager.destroy();
							},
							function (data) {
								modalManager.showError('There was an error submitting your report');
								$('.modal-submit').removeClass('submit-waiting').prop('disabled', false);
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					reportBarkReview: function (reviewId, reportType, notes) {
						var t = this;
						Bark.api(
							'seller/review/report',
							{
								rid: reviewId,
								type: reportType,
								notes: notes,
							},
							function (data) {
								$('#bark-review-' + reviewId)
									.find('.review-links')
									.addClass('reported');
								modalManager.destroy();
							},
							function (data) {
								modalManager.showError(_t('seller_settings_profile:reviews-section.review-reporting.errors.error-submitting-report'));
								$('.modal-submit').removeClass('submit-waiting').prop('disabled', false);
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					editBarkReviewResponse: function (reviewId, message) {
						var t = this;
						Bark.api(
							'seller/review/respond',
							{
								rid: reviewId,
								message: message,
							},
							function (data) {
								$('#bark-review-' + reviewId)
									.find('.edit-response-link')
									.data('response', message);
								$('#bark-review-' + reviewId)
									.find('.edit-response-link .response-link-text')
									.text(_t('seller_settings_profile:reviews-section.edit-response-link'));
								modalManager.destroy();
							},
							function (data) {
								modalManager.showError(_t('seller_settings_profile:reviews-section.review-reporting.errors.error-submitting-response'));
								$('.modal-submit').removeClass('submit-waiting').prop('disabled', false);
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					showReportModal: function (type, reviewId) {
						var t = this;
						modalManager.set(
                            _t('seller_settings_profile:reviews-section.review-reporting.title'),
                            _t('seller_settings_profile:reviews-section.review-reporting.description'),
							this.reportReviewTemplate({
								review_id: reviewId,
								type: type,
							}),
							[
								modalManager.cancelLinkHTML(),
								modalManager.submitButtonHTML(_t('seller_settings_profile:accordion-buttons.report'), true),
							],
							[],
						);
						modalManager.setEvent('change', '[name="report-type"]', {}, function (e) {
							$('.modal-submit').prop('disabled', false);
						});
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							var $form = $('.report-form');
							var reviewProvider = $form.find('#review-provider').val();
							var reviewId = $form.find('#review-id').val();
							var reportType = $form.find('[name="report-type"]:checked').val();
							var notes = $form.find('#report-notes').val();
							reviewId = parseInt(reviewId);
							$('.modal-submit').addClass('submit-waiting').prop('disabled', true);
							if (reviewProvider === 'bark') {
								t.reportBarkReview(reviewId, reportType, notes);
							} else {
								t.reportExternalReview(reviewProvider, reviewId, reportType, notes);
							}
						});
					},
					showResponseModal: function (reviewId, message) {
						var t = this;
						modalManager.set(
                            _t('seller_settings_profile:reviews-section.review-response.title'),
                            _t('seller_settings_profile:reviews-section.review-response.description'),
							this.respondReviewTemplate({
								review_id: reviewId,
								message: message,
							}),
							[
								modalManager.cancelLinkHTML(),
								modalManager.submitButtonHTML(_t('seller_settings_profile:accordion-buttons.respond'), true),
							],
							[],
						);
						modalManager.setEvent('keyup', '#response-message', {}, function (e) {
							$('.modal-submit').prop('disabled', false);
						});
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							var $form = $('.respond-form');
							var reviewId = $form.find('#review-id').val();
							var message = $form.find('#response-message').val();
							reviewId = parseInt(reviewId);
							$('.modal-submit').addClass('submit-waiting').prop('disabled', true);
							t.editBarkReviewResponse(reviewId, message);
						});
					},
					saveReviewSourceSettings: function (defer) {
						var t = this;
						if (Object.keys(t.changedReviewSourceIDs).length > 0) {
							// send a payload of the changed review sources and their visibility status
							// to the new API endpoint.v

							var payload = {
								external_sources: t.changedReviewSourceIDs,
							};
							Bark.api(
								'seller/reviews/providers/',
								payload,
								function (data) {
									t.getReviews('all');
									t.getReviewsSummary();

									formManager.dirty(t.reviewSourcesHandle, false);
									t.changedReviewSourceIDs = {};
									defer.resolve();
									updateCompletionPercentages(data.progress, 'reviews', 'reviews');
								},
								function (err) {
									var errorMessage = handleErrors(
										err,
                                        _t('seller_settings_profile:reviews-section.external-review-settings.error-saving'),
									);
									addFormError($('.review-sources-list-container'), errorMessage);
									t.changedReviewSourceIDs = {};
									formManager.dirty(t.reviewSourcesHandle, false);
									defer.resolve();
								},
								'POST',
								Bark.apiVersionHeader('v2'),
							);
						} else {
							defer.resolve();
							t.changedReviewSourceIDs = {};
							formManager.dirty(t.reviewSourcesHandle, false);
						}
					},

					importBidvineReviewData: function (defer) {
						Bark.api(
							'seller/reviews/bidvine/import',
							[],
							function (data) {
								modalManager.hideLoading();
								if (!data.status) {
									modalManager.showError(
										_t('seller_settings_profile:reviews-section.bidvine.errors.importing.description'),
									);
									defer.reject();
								}
								defer.resolve();
							},
							function (error) {
								modalManager.hideLoading();
								var err = handleErrors(error, _t('seller_settings_profile:reviews-section.bidvine.errors.importing.title'));
								modalManager.showError(err.msg);
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);

						$('.modal.show').modal('hide');
					},
					dismissBidvineReviewData: function (defer) {
						Bark.api(
							'seller/reviews/bidvine/dismiss',
							[],
							function (data) {
								modalManager.hideLoading();
								if (data.status) {
								} else {
									modalManager.showError(
                                        _t('seller_settings_profile:reviews-section.bidvine.errors.dismissing.description'),
									);
									defer.reject();
								}
								defer.resolve();
							},
							function (error) {
								modalManager.hideLoading();
								var err = handleErrors(error, _t('seller_settings_profile:reviews-section.bidvine.errors.dismissing.title'));
								modalManager.showError(err.msg);
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					addListeners: function () {
						var t = this;
						$('.review-invite-link').on('click', function (e) {
							e.preventDefault();
							t.inviteForReview();
						});
						$('.review-sources-list-container').on(
							'click',
							'input.review-source-visibility',
							function (e) {
								var sourceId = $(this).data('review-source');
								var sourceName = t.getReviewSourceNameFromId(sourceId);
								t.toggleReviewSource(sourceId, $(this).is(':checked'));
								$('.all-reviews .review-items .source-' + sourceName).each(function (e) {
									$(this).toggleClass('source-disabled', t.isSourceHidden(sourceName));
								});
								if (t.changedReviewSourceIDs.hasOwnProperty(sourceId)) {
									delete t.changedReviewSourceIDs[sourceId];
								} else {
									t.changedReviewSourceIDs[sourceId] = $(this).is(':checked')
										? true
										: false;
								}
								formManager.dirty(
									t.reviewSourcesHandle,
									!$.isEmptyObject(t.changedReviewSourceIDs),
								);
							},
						);
						$('.reviews-container').on('click', '.report-link', function (e) {
							e.preventDefault();
							var $container = $(this).closest('.review-item');
							t.showReportModal($container.data('type'), $container.data('review-id'));
						});
						$('.reviews-container').on('click', ' .pagination .page-link', function (e) {
							e.preventDefault();
							var newPage = $(this).data('page');
							var provider = $(this).closest('.pagination').data('provider');
							t.getReviews(provider, newPage);
							window.quickScroll('#' + provider + '-reviews-container', -200);
						});
						$('.reviews-container').on('click', '.edit-response-link', function (e) {
							e.preventDefault();
							var $container = $(this).closest('.review-item');
							var response = $(this).data('response');
							if (!response) {
								response = '';
							}
							t.showResponseModal($container.data('review-id'), response);
						});
						$('.copy-button').each(function () {
							$(this).on('click', function (e) {
								var codeInput = $('#' + $(this).data('target'));
								codeInput.select();
								if (document.execCommand('copy')) {
									$(this).popover('show');
									var button = $(this);
									setTimeout(function () {
										button.popover('hide');
									}, 1000);
								} else {
									var el = codeInput.get(0);
									var oldCE = el.contentEditable;
									var oldReadOnly = el.readOnly;
									var range = document.createRange();
									el.contentEditable = true;
									el.readOnly = false;
									range.selectNodeContents(el);
									var s = window.getSelection();
									s.removeAllRanges();
									s.addRange(range);
									el.setSelectionRange(0, 99999);
									el.contentEditable = oldCE;
									el.readOnly = oldReadOnly;
									if (!document.execCommand('copy')) {
										modalManager.set(
											'Unable to copy',
											'',
											'<p class="mb-0">' + _t('seller_settings_profile:invite-reviews.error.cant-copy') + '</p>',
											[modalManager.basicOkayButtonHTML()],
											'modal-sm',
										);
									} else {
										$(this).popover('show');
										var button = $(this);
										setTimeout(function () {
											button.popover('hide');
										}, 1000);
									}
								}
							});
						});
						$('.all-reviews').on('change', '#review-sort-order', function (e) {
							e.preventDefault();
							var reviewsContainer = $('.all-reviews');
							var newOrder = $(this).val();
							t.setReviewSort(newOrder);
							t.getReviews('all');
						});
						$.when(
							this.callRegisters['bark_reviews'],
							this.callRegisters['all_reviews'],
							// this.callRegisters['facebook_reviews'],
							// this.callRegisters['google_reviews']
						).then(function () {
							$('.review-sources').removeClass('waiting');
							$('.review-counts').removeClass('waiting');
							sectionLoaded(
								$('.reviews-root-container'),
								$('.reviews-root-container .has-reviews').length > 0,
							);
							const isDismissed =
								$('.bidvine-reviews-total-int').data('bidvine-reviews-dismiss') ?? true;
							if (undefined !== QS.getValue('import_bidvine') && !isDismissed) {
								$('.import-bidvine-reviews-button').click();
							}
						});

						$('.import-bidvine-reviews-button')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								const bidVineReviewCount =
									$('.bidvine-reviews-total-int').data('bidvine-reviews-count') ?? 0;
								window.modalManager.set(
									'',
									'',
									t.bidvineReviewImportModalTemplate({
										bidVineReviewCount: bidVineReviewCount,
										reviewPluralized: bidVineReviewCount === 1 ? 'review' : 'reviews',
									}),
									[
										modalManager.cancelLinkHTML(_t('seller_settings_profile:reviews-section.bidvine.import-reviews.cancel-link')),
										modalManager.submitButtonHTML(_t('seller_settings_profile:reviews-section.bidvine.import-reviews.confirm-button')),
									],
								);
								modalManager.setEvent('click.submit', '.modal-submit', {}, function () {
									startSubmit($(this));
									let defer = $.Deferred();
									t.importBidvineReviewData(defer);
									defer
										.then(function () {
											reviews.getReviewsSummary();
											reviews.getReviews('bark', 1);
										})
										.done(function () {
											$('.review-counts .display-no-reviews').hide();
											$('.review-counts .display-has-reviews').show();
											$('.bidvine-reviews').addClass('waiting');
											$('.modal.show').modal('hide');
										});
								});
							});
						$('.dismiss-bidvine-reviews-button')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								window.modalManager.set('', '', t.bidvineReviewDismissModalTemplate({}), [
									modalManager.cancelLinkHTML(_t('seller_settings_profile:reviews-section.bidvine.delete-reviews.cancel-link')),
									modalManager.submitButtonHTML(_t('seller_settings_profile:reviews-section.bidvine.delete-reviews.confirm-button')),
								]);
								modalManager.setEvent('click.submit', '.modal-submit', {}, function () {
									startSubmit($(this));
									let defer = $.Deferred();
									t.dismissBidvineReviewData(defer);
									defer.done(function () {
										$('.modal.show').modal('hide');
										$('.bidvine-reviews').addClass('waiting');
									});
								});
							});
					},
				};

				Object.assign(this, instanceVars);

				this.initialise();

				return this;
			}

			function SocialMediaWebLinks() {
				var instanceVars = {
					formManagerHandle: 'profile-social-media-links',
					toggles: ['facebook', 'twitter', 'links'],
					initialise: function () {
						var t = this;
						formManager.register(
							this.formManagerHandle,
							function (defer) {
								t.updateLinks(defer);
							},
							function () {
								$('#web-links-list').val($('#web-links-list').data('original'));
								$('#twitter-username').val($('#twitter-username').data('original'));
								$('#facebook-url').val($('#facebook-url').data('original'));
								t.removeFormErrors();
								t.toggles.map((id) => {
									let el = $(`#enable-${id}`);
									el.prop('checked', el.data('original'));
									handleToggleSectionHiding(el);
								});
								formManager.dirty(t.formManagerHandle, false);
							},
						);
					},
					removeFormErrors: function () {
						removeFormErrors($('#web-links-list').parent());
						removeFormErrors($('#twitter-username').parent());
						removeFormErrors($('#facebook-url').parent());
					},
					populateData: function (selfData) {
						var t = this;
						let showTooltip = selfData.external_links.length === 0;
						t.populateLinks(selfData.external_links);
						var twitter = '';
						if (typeof selfData.links.twitter != 'undefined') {
							twitter = selfData.links.twitter;
							showTooltip = false;
						}
						var facebook = '';
						if (typeof selfData.links.facebook != 'undefined') {
							facebook = selfData.links.facebook;
							showTooltip = false;
						}
						$('#twitter-username').val(twitter).data('original', twitter);
						$('#facebook-url').val(facebook).data('original', facebook);
						t.toggles.map((id) => {
							const toggleElement = $(`#enable-${id}`)
								.prop('checked', selfData.toggles[id])
								.data('original', selfData.toggles[id]);
							showTooltip = showTooltip && selfData.toggles[id];
							handleToggleSectionHiding(toggleElement);
						});
						t.handleToggleTooltip(showTooltip);
						t.addListeners();
						// calculate success for this section
						sectionLoaded($('.social-media-subsection'));
						$('.web-links-subsection').removeClass('waiting');
						$('.social-media-subsection').removeClass('waiting');
					},
					handleToggleTooltip: (autoshow) => {
						let el = $('#enable-facebook').parent().parent().find('.toggle-info');
						if (autoshow && !el.hasClass('prevent-auto-tooltip')) {
							el.addClass('auto-tooltip');
						} else {
							el.addClass('prevent-auto-tooltip');
						}
					},
					updateLinks: function (defer) {
						var t = this;
						t.removeFormErrors();
						//toggles:
						let toggledData = {
							facebook: $('#enable-facebook').prop('checked') ? 1 : 0,
							twitter: $('#enable-twitter').prop('checked') ? 1 : 0,
							links: $('#enable-links').prop('checked') ? 1 : 0,
						};
						var links = $('#web-links-list').val().split('\n');
						var twitter = $('#twitter-username').val();
						var facebook = $('#facebook-url').val().trim();

						if (
							toggledData['facebook'] &&
							facebook &&
							!/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(facebook)
						) {
							addFormError($('#facebook-url'), _t('seller_settings_profile:social-media-section.errors.not-facebook'));
							defer.reject($('#facebook-url'));
							return;
						}
						if (toggledData['twitter'] && twitter && !/^@?(\w){1,15}$/i.test(twitter)) {
							addFormError(
								$('#twitter-username'),
                                _t('seller_settings_profile:social-media-section.errors.not-twitter'),
							);
							defer.reject($('#twitter-username'));
							return;
						}
						links = links.map(function (link) {
							return link.trim();
						});
						links = links.filter(function (link) {
							if (link.length > 0) {
								return true;
							}
							return false;
						});

						if (!links.length) {
							links = null;
						}

						let payload = {
							links: {
								twitter: twitter,
								facebook: facebook,
							},
							toggles: toggledData,
						};

						if (toggledData['links']) {
							payload.external_links = links;
						}

						// todo cleanup API call
						Bark.api(
							'seller/profile',
							payload,
							function (data) {
								removeFormErrors($('#web-links-list').parent());
								if (links) t.populateLinks(links);
								$('#twitter-username').data('original', twitter);
								$('#facebook-url').data('original', facebook);
								t.toggles.map((id) => {
									const toggleElement = $(`#enable-${id}`);
									toggleElement.data('original', toggleElement.prop('checked'));
								});
								t.handleToggleTooltip(false);
								formManager.dirty(t.formManagerHandle, false);
								defer.resolve();
								updateCompletionPercentages(
									data.progress,
									'social-media-and-links',
									'links',
								);
							},
							function (data) {
								var errorData = handleErrors(data);
								var validationErrors = errorData['validation'];
								var errorArr = [];
								Object.keys(validationErrors).forEach(function (key) {
									var index = parseInt(key.split('.')[1]);
									if (typeof links[index] !== 'undefined') {
										errorArr.push(validationErrors[key][0].replace(key, links[index]));
									}
								});
								t.handleToggleTooltip(false);
								addFormError($('#web-links-list'), errorArr.join(', '));
								defer.reject($('#web-links-list'));
							},
							'PUT',
							Bark.apiVersionHeader('v2'),
						);
					},
					populateLinks: function (links) {
						var t = this;
						var actualLinks = [];
						Object.values(links).forEach(function (link) {
							if (link !== '') {
								actualLinks.push(link);
							}
						});
						$('#web-links-list').val(actualLinks.join('\n'));
						$('#web-links-list').data('original', actualLinks.join('\n'));
						$('.web-links').removeClass('waiting');
					},
					addListeners: function () {
						var t = this;
						$('#web-links-list')
							.off('change.formlisten, keyup.formlisten')
							.on('change.formlisten, keyup.formlisten', function () {
								formManager.dirty(t.formManagerHandle);
							});
						$('#twitter-username')
							.off('change.formlisten, keyup.formlisten')
							.on('change.formlisten, keyup.formlisten', function () {
								formManager.dirty(t.formManagerHandle);
							});
						$('#facebook-url')
							.off('change.formlisten, keyup.formlisten')
							.on('change.formlisten, keyup.formlisten', function () {
								formManager.dirty(t.formManagerHandle);
							});
						$('#enable-facebook, #enable-twitter, #enable-links')
							.off('change.formlisten, keyup.formlisten')
							.on('change.formlisten, keyup.formlisten', function () {
								formManager.dirty(t.formManagerHandle);
								handleToggleSectionHiding($(this));
							});
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function Services() {
				var instanceVars = {
					serviceFormTemplate: Handlebars.compile(
						document.getElementById('service-template').innerHTML,
					),
					serviceItemTemplate: Handlebars.compile(
						document.getElementById('service-item-template').innerHTML,
					),
					toSave: [],
					toDelete: [],
					selfContainer: $('.services-container'),
					formManagerHandle: 'services-section-form',
					newServicePrefix: 'new-svc-',
					newServiceIndex: 1,
					initialise: function () {
						var t = this;
						this.populateData();
						this.addListeners();
						formManager.register(
							this.formManagerHandle,
							function (defer) {
								let d1 = $.Deferred();
								let d2 = $.Deferred();
								t.uploadServiceData(d1);
								d1.done(() => {
									t.uploadServiceDeletions(d2);
								});
								$.when(d1, d2).then(
									() => {
										t.populateData(true);
										t.toSave = [];
										t.toDelete = [];
										formManager.dirty(t.formManagerHandle, false);
										defer.resolve();
									},
									() => {
										defer.reject();
									},
								);
							},
							function () {
								t.toDelete.forEach((svcToDelete) => {
									t.getServiceItembyId(svcToDelete).removeClass('to-be-deleted');
								});
								t.toSave.forEach((newService) => {
									if (!newService.id.startsWith(t.newServicePrefix)) {
										let svcItem = t.getServiceItembyId(newService.id);
										svcItem.slideUp(400, () => {
											svcItem.removeClass('d-flex').remove();
										});
									}
								});
								t.toSave = [];
								t.toDelete = [];
								t.populateData('true');
								formManager.dirty(t.formManagerHandle, false);
							},
						);
					},
					getServiceItembyId: (svcId) => {
						return $(`.service-item[data-svcid="${svcId}"]`);
					},
					removeOldService: function (svcid) {
						this.getServiceItembyId(svcid).remove();
					},
					appendNewService: function (svc, replaceOld) {
						let templateContent = this.serviceItemTemplate({
							title: $(`<div>${svc.title}</div>`).text(),  // Ensure tags are stripped
							summary: $(`<div>${svc.summary}</div>`).text(),  // Ensure tags are stripped
							id: svc.id,
						});
						if (replaceOld) {
							this.getServiceItembyId(svc.id).replaceWith(templateContent);
						} else {
							$('.services-list').append(templateContent);
						}
					},
					populateData: (skipSectionLoaded) => {
						var t = this;
						skipSectionLoaded = skipSectionLoaded ?? false;
						t.selfContainer.toggleClass('waiting', true);
						Bark.api(
							'/seller/extra/services',
							{},
							function (data) {
								if (data.status) {
									$('.services-list').empty();
									t.selfContainer.removeClass('waiting');
									let success = 0;
									data.services.forEach(function (svc) {
										success += 1;
										t.appendNewService(svc);
									});
									t.addItemListeners();
									if (!skipSectionLoaded) {
										sectionLoaded(t.selfContainer);
									}
								}
							},
							function (err) {
								t.selfContainer.removeClass('waiting');
								if (!skipSectionLoaded) {
									sectionLoaded(t.selfContainer);
								}
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					saveServiceData: function (element, title, summary, svcid) {
						if (typeof svcid === 'undefined') {
							svcid = false;
						}
						var t = this;
						if (!title || title.length < 2) {
							modalManager.showError(_t('seller_settings_services:errors.title-too-short'));
							endSubmit(element);
						} else {
							var payload = {
								title: title,
								summary: summary && summary.length > 0 ? summary : false,
							};
							let replacedElement = false;
							if (!svcid) {
								payload.id = t.newServicePrefix + t.newServiceIndex;
								t.newServiceIndex += 1;
							} else {
								payload.id = svcid;
								t.toSave.forEach((svc, i) => {
									if (!replacedElement && svc.id === payload.id) {
										t.toSave[i] = { ...payload };
										replacedElement = true;
									}
								});
							}
							if (!replacedElement) {
								t.toSave.push(payload);
							}
							t.appendNewService(payload, t.getServiceItembyId(payload.id).length === 1);
							formManager.dirty(t.formManagerHandle, t.toSave);
							t.addItemListeners();
							$('.modal.show').modal('hide');
						}
					},
					uploadServiceData: (defer) => {
						let t = this;
						let services = t.toSave.map((item) => {
							if (String(item.id).startsWith(t.newServicePrefix)) {
								delete item.id;
							}
							return item;
						});
						if (services.length === 0) {
							defer.resolve();
							return;
						}
						let payload = {
							services,
						};
						modalManager.showLoading();
						Bark.api(
							'sellerprofile/services',
							payload,
							function (data) {
								modalManager.hideLoading();
								if (data.status) {
									updateCompletionPercentages(data.progress, 'services', 'services');
								} else {
									modalManager.showError(
                                        _t('seller_settings_services:errors.cant-save'),
									);
									defer.reject();
								}
								defer.resolve();
							},
							function (error) {
								modalManager.hideLoading();
								var err = handleErrors(error, _t('seller_settings_services:errors.error-saving'));
								modalManager.showError(err.msg);
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					uploadServiceDeletions: (defer) => {
						let t = this;
						let services = t.toDelete.filter((svcId) => {
							return !String(svcId).startsWith(t.newServicePrefix);
						});
						if (services.length === 0) {
							defer.resolve();
							return;
						}
						let payload = {
							services,
						};
						Bark.api(
							'/sellerprofile/services/delete',
							payload,
							function (data) {
								modalManager.hideLoading();
								if (data.status) {
									updateCompletionPercentages(data.progress, 'services', 'services');
								} else {
									modalManager.showError(
                                        _t('seller_settings_services:errors.cant-delete'),
									);
									defer.reject();
								}
								defer.resolve();
							},
							function (error) {
								modalManager.hideLoading();
								let err = handleErrors(error, _t('seller_settings_services:errors.error-deleting'));
								modalManager.showError(err.msg);
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},
					deleteService: function (svcid) {
						let t = this;
						if (typeof svcid == 'undefined') {
							svcid = false;
						}
						if (!svcid) {
							return;
						}
						t.toDelete.push(svcid);
						t.toSave = t.toSave.filter((svc) => svc.id !== svcid);
						formManager.dirty(t.formManagerHandle, t.toDelete.length > 0);
					},
					addListeners: function () {
						var t = this;
						$('.add-service-button')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								window.modalManager.set(
                                    _t('seller_settings_services:add-service.title'),
                                    _t('seller_settings_services:add-service.description'),
									t.serviceFormTemplate({}),
									modalManager.defaultActionButtons(),
								);
								modalManager.setEvent('click.submit', '.modal-submit', {}, function () {
									startSubmit($(this));
									var title = $('#service_type').val().replace("<", "&lt;").replace(">", "&gt;");
									var summary = $('#service_description').val().replace("<", "&lt;").replace(">", "&gt;");
									t.saveServiceData($(this), title, summary);
								});
							});
					},
					addItemListeners: function () {
						var t = this;
						$('.services-list .service-item .edit-service-button')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								var svcId = $(this).data('svcid');

								var title = $(this).data('svctitle').replace("<", "&lt;").replace(">", "&gt;");
								var summary = $(this).data('svcsummary').replace("<", "&lt;").replace(">", "&gt;");

								window.modalManager.set(
									cleanse(title),
									'Editing',
									t.serviceFormTemplate({
										svcid: svcId,
										serviceType: cleanse(title),
										serviceDescription: cleanse(summary),
									}),
									modalManager.defaultActionButtons(),
								);
								modalManager.setEvent('click.submit', '.modal-submit', {}, function () {
									startSubmit($(this));
									var svcId = $('#svcid').val();
									var title = $('#service_type').val().replace("<", "&lt;").replace(">", "&gt;");
									var summary = $('#service_description').val().replace("<", "&lt;").replace(">", "&gt;");
									t.saveServiceData($(this), title, summary, svcId);
								});
							});
						$('.delete-service')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								var svcId = $(this).data('svcid');
								$(this).closest('.service-item').addClass('to-be-deleted');
								if (svcId) {
									t.deleteService(svcId);
								}
							});
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function Prices() {
				if ($('#price-service-template').length < 1) {
					return;
				}
				var instanceVars = {
					priceRowTemplate: Handlebars.compile(
						document.getElementById('price-service-template').innerHTML,
					),
					priceEditModal: Handlebars.compile(
						document.getElementById('price-edit-form').innerHTML,
					),
					formManagerHandle: 'prices-section-form',
					pricesListEl: $('.prices-list'),
					pricesContainerEl: $('.prices-container'),
					pricesToSave: [],
					pricesToDelete: [],
					initialise: function () {
						var t = this;
						this.populateData();
						this.addListeners();
						formManager.register(
							t.formManagerHandle,
							(defer) => {
								let d1 = $.Deferred();
								let d2 = $.Deferred();
								t.uploadPriceData(d1);
								d1.done(() => {
									t.uploadDeletedPrices(d2);
								});
								$.when(d1, d2).then(
									() => {
										t.populateData(true);
										t.pricesToDelete = [];
										t.pricesToSave = [];
										formManager.dirty(t.formManagerHandle, false);
										defer.resolve();
									},
									() => {
										defer.reject();
									},
								);
							},
							() => {
								t.pricesToDelete = [];
								t.pricesToSave = [];
								t.populateData(true);
								formManager.dirty(t.formManagerHandle, false);
							},
						);
					},
					appendPrice: (
						{
							category_id,
							category_name,
							base_price,
							currency_symbol,
							price_unit,
							discounts,
							addons,
						},
						replaceTarget,
					) => {
						let t = this;
						let templateContent = t.priceRowTemplate({
							category_id: category_id,
							category_name: category_name,
							price_value: base_price
								? format_currency(base_price, true, currency_symbol)
								: '',
							currency_symbol: currency_symbol ?? '£', // this must come from API, it won't really make sense to fallback to gbp -- todo, figure out fallback
							price_unit: price_unit === 'onceoff' ? '' : price_unit,
							has_discount: discounts && true,
							discount: discounts,
							has_addon: addons && true,
							addon: addons,
							price_value_raw: base_price,
						});
						if (replaceTarget) {
							replaceTarget.replaceWith(templateContent);
						} else {
							t.pricesListEl.append(templateContent);
						}
					},
					updatePriceRow: (newPriceData) => {
						let t = this;
						let existingPriceEl = t.pricesListEl.find(
							`.price-service-item[data-category-id="${newPriceData.category_id}"]`,
						);
						if (existingPriceEl) {
							let existingData = existingPriceEl.data();
							t.appendPrice(
								{
									base_price: existingData['priceValue'],
									category_id: existingData['categoryId'],
									category_name: existingData['categoryName'],
									currency_symbol: existingData['currencySymbol'],
									price_unit: existingData['priceUnit'],
									discounts: existingData['discount'],
									addons: existingData['addon'],
									...newPriceData,
								},
								existingPriceEl,
							);
						}
					},
					populateData: function (skipSectionLoaded) {
						var t = this;
						t.pricesContainerEl.toggleClass('waiting', true);
						Bark.api(
							'seller/prices/all/',
							{},
							function (data) {
								if (data.data) {
									t.pricesListEl.empty();
									t.pricesContainerEl.removeClass('waiting');
									Object.keys(data.data).forEach(function (catId) {
										var price = data.data[catId];
										t.appendPrice(price);
									});
									if (!skipSectionLoaded) {
										sectionLoaded(t.pricesContainerEl);
									}
									t.addItemListeners();
								} else {
									t.pricesContainerEl.removeClass('waiting');
								}
							},
							function (err) {
								t.pricesContainerEl.removeClass('waiting');
							},
							'GET',
							Bark.apiVersionHeader('v1'),
						);
					},
					savePriceData: function (catId, price, discount, addon) {
						let t = this;
						let errorText = '';
						if (price < 1) {
							errorText = _t('seller_settings_pricing:errors.minimum-price'); // @TODO: Should really use currency symbol variable - not currently available in this scope.
						}

						/* Quick regex to only allow numeric input */
						if (!price.match(/^-?\d+\.?\d{0,2}$/)) {
							errorText = _t('seller_settings_pricing:errors.number');
						}

						if (errorText !== '') {
							modalManager.showError(errorText);
						} else {
							let payload = {
								category_id: catId,
								base_price: Math.round(price * 100),
								discounts: discount,
								addons: addon,
							};
							if (t.pricesToDelete.length > 0) {
								t.pricesToDelete.filter((categoryToDelete) => {
									return String(catId) !== String(categoryToDelete);
								});
							}
							t.pricesToSave.push(payload);
							t.updatePriceRow(payload);
							t.addItemListeners();
							formManager.dirty(t.formManagerHandle, t.pricesToSave.length > 0);
							$('.modal.show').modal('hide');
						}
					},
					uploadPriceData: (defer) => {
						let t = this;
						if (t.pricesToSave.length === 0) {
							defer.resolve();
							return;
						}
						Bark.api(
							'seller/profile/prices/',
							{
								prices: t.pricesToSave,
							},
							function (data) {
								if (data.status) {
									defer.resolve();
									updateCompletionPercentages(
										data.progress,
										'services-prices',
										'services',
									);
								} else {
									defer.reject();
								}
							},
							function (error) {
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v1'),
						);
					},
					deletePrice: function (catId) {
						let t = this;
						if (!catId) {
							return;
						}

						if (-1 === t.pricesToDelete.indexOf(catId)) {
							t.pricesToDelete.push(catId);
						}

						if (t.pricesToSave.length > 0) {
							// if we are deleting, we cannot be saving.
							t.pricesToSave.filter(({ categoryIdToSave }) => {
								return String(categoryIdToSave) !== String(catId);
							});
						}
						t.updatePriceRow({
							base_price: '',
							discounts: '',
							addons: '',
							category_id: catId,
						});
						t.addItemListeners();
						formManager.dirty(t.formManagerHandle, t.pricesToDelete.length);
					},
					uploadDeletedPrices: (defer) => {
						let t = this;
						if (t.pricesToDelete.length === 0) {
							defer.resolve();
							return;
						}
						// just upload this.category IDs to delete prices for
						Bark.api(
							'seller/profile/prices/delete/',
							{ category_ids: t.pricesToDelete },
							function (data) {
								if (data.status) {
									updateCompletionPercentages(
										data.progress,
										'services-prices',
										'services',
									);
									defer.resolve();
								}
								defer.reject();
							},
							function (error) {
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v1'),
						);
					},
					addListeners: function () {},
					addItemListeners: function () {
						var t = this;
						$(
							'.prices-list .price-service-item .js-edit-price, .prices-list .price-service-item .js-add-price',
						)
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								var row = $(this).closest('.price-service-item');
								var subtitle =
									'Add your prices for your ' +
									$(this).closest('.price-service-item').data('category-name') +
									' services';
								var payload = {
									has_addon: row.data('addon'),
									addon_text: row.data('addon'),
									has_discount: row.data('discount'),
									discount_text: row.data('discount'),
									price_unit: row.data('price-unit').replace('/', 'per '),
									price_value: row.data('price-value') / 100.0,
									category_id: row.data('category-id'),
									currency_symbol: row.data('currency-symbol'),
								};

								const showModalCallback = () => {
									if (window.isAndroid() && $(window).width() < 767) {
										$('body').addClass('android-modal-open');
									}
								};

								const hideModalCallback = () => {
									$('body').removeClass('android-modal-open');
								};

								window.modalManager.set(
									'Add pricing',
									subtitle,
									t.priceEditModal(payload),
									[
										modalManager.cancelLinkHTML(_t('seller_settings_profile:accordion-buttons.back')),
										modalManager.submitButtonHTML(_t('seller_settings_profile:accordion-buttons.save')),
									],
									[],
									[
										{ type: 'show.bs.modal', callback: showModalCallback },
										{ type: 'hide.bs.modal', callback: hideModalCallback },
									],
								);

								// setup the toggles
								modalManager.setEvent('change.toggle', '#addon-enabled', {}, function () {
									$('#addons').prop('disabled', !$(this).prop('checked'));
								});
								modalManager.setEvent(
									'change.toggle',
									'#discount-enabled',
									{},
									function () {
										$('#discounts').prop('disabled', !$(this).prop('checked'));
									},
								);
								//validate and submit
								modalManager.setEvent('click.submit', '.modal-submit', {}, function () {
									startSubmit($(this));
									let catId = $('#category_id').val();
									let priceVal = $('#price-value').val();
									let discount = $('#discount-enabled').prop('checked')
										? $('#discounts').val().trim()
										: '';
									let addon = $('#addon-enabled').prop('checked')
										? $('#addons').val().trim()
										: '';
									t.savePriceData(catId, priceVal, discount, addon);
									endSubmit($(this));
								});
							});
						$('.js-delete-price')
							.off('click.edit')
							.on('click.edit', function (e) {
								e.preventDefault();
								let catId = $(this).closest('.price-service-item').data('category-id');
								t.deletePrice(catId);
							});
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function PhotosAndVideos() {
				var t = this,
					photos = 0,
					videos = 0;

				function validateYoutubeUrl(url) {
					if (url != undefined || url != '') {
						var regExp = /youtube\.com.*(\?v=|\/embed\/)(.{11})/;
						var match = url.match(regExp);
						return match && match[2].length == 11;
					}
					return false;
				}
				var instanceVars = {
					formManagerHandle: 'media-section',
					videosToggle: $('#enable-videos'),
					photoGalleryEl: $('.photo-gallery'),
					videoGalleryEl: $('.video-gallery'),
					loadingImageUrl: 'https://www.placehold.it/150x150.png',
					newVideoIndex: 0,
					newPhotoIndex: 0,
					newVideoPrefix: 'new-video-',
					newPhotoPrefix: 'new-photo-',
					imagesToSave: [],
					videosToSave: [],
					photoTemplate: Handlebars.compile(
						document.getElementById('photo-template').innerHTML,
					),
					photoViewTemplate: Handlebars.compile(
						document.getElementById('photo-view-template').innerHTML,
					),
					photoDeleteTemplate: Handlebars.compile(
						document.getElementById('photo-delete-template').innerHTML,
					),
					videoAddTemplate: Handlebars.compile(
						document.getElementById('video-add-template').innerHTML,
					),
					videoTemplate: Handlebars.compile(
						document.getElementById('video-template').innerHTML,
					),
					videoDeleteTemplate: Handlebars.compile(
						document.getElementById('video-delete-template').innerHTML,
					),
					resetAttributes: () => {
						t.newPhotoIndex = 0;
						t.newVideoIndex = 0;
						t.videosToSave = [];
						t.imagesToSave = [];
					},
					initialise: function () {
						const t = this;
						t.addListeners();
						t.getMedia();
						formManager.register(
							t.formManagerHandle,
							function (defer) {
								let d1 = $.Deferred();
								let d2 = $.Deferred();
								let d3 = $.Deferred();
								t.updateYoutubeToggle(d1);
								t.uploadImages(d2);
								t.uploadVideos(d3);
								$.when(d1, d2, d3).then(
									() => {
										t.resetAttributes();
										formManager.dirty(t.formManagerHandle, false);
										defer.resolve();
									},
									() => {
										defer.reject();
									},
								);
							},
							function () {
								t.videosToggle.prop('checked', t.videosToggle.data('original'));
								handleToggleSectionHiding(t.videosToggle);
								t.resetAttributes();
								t.getMedia();
								t.addListeners();
								formManager.dirty(t.formManagerHandle, false);
							},
						);
					},
					populateData: function (selfData) {
						const toggleYoutube = selfData.toggles['youtube'];
						t.videosToggle.prop('checked', toggleYoutube).data('original', toggleYoutube);
						t.handleToggleTooltip(toggleYoutube);
						handleToggleSectionHiding(t.videosToggle);
					},
					handleToggleTooltip: (autoshow) => {
						let el = t.videosToggle.parent().parent().find('.toggle-info');
						if (autoshow && !el.hasClass('prevent-auto-tooltip')) {
							el.addClass('auto-tooltip');
						} else {
							el.addClass('prevent-auto-tooltip');
						}
					},
					removeVideoElement: (video) => {
						t.videoGalleryEl
							.find(`input.gallery-video-${video.videoRef}`)
							.parent()
							.remove();
					},
					removePhotoElement: (photo) => {
						t.photoGalleryEl
							.find(`img#gallery-photo-${photo.id}`)
							.closest('.gallery-photo-container')
							.remove();
					},
					appendPhotoElement: (photo, replace) => {
						let htmlContent = t.photoTemplate({
							photoId: photo.id,
							photoType: photo.type,
							photoUrl: photo.scaled_url ? photo.scaled_url : photo.url,
							photoRef: photo.photoRef ?? photo.id,
							is_new: photo.is_new ?? false,
						});
						if (replace) {
							replace.replaceWith(htmlContent);
						} else {
							t.photoGalleryEl.append(htmlContent);
						}
					},
					appendVideoElement: ({ videoRef, thumbnailUrl, is_new }, replace) => {
						let html = t.videoTemplate({
							thumbnailUrl: thumbnailUrl,
							videoRef: videoRef,
							is_new: is_new ?? false,
						});
						if (replace) {
							replace.replaceWith(html);
						} else {
							t.videoGalleryEl.append(html);
						}
					},
					toggleEmptyPhotosMessage: (show) => {
						if (show) $('.photo-gallery .empty-gallery-message').show();
						else $('.photo-gallery .empty-gallery-message').hide();
					},
					getMedia: function () {
						$('.images-subsection, .videos-subsection').addClass('waiting');
						Bark.api(
							'seller/media',
							{},
							function (data) {
								t.photoGalleryEl.find('.gallery-photo-container').remove();
								t.toggleEmptyPhotosMessage(true);
								$('.video-gallery .empty-gallery-message').show();
								$('.images-subsection, .videos-subsection').removeClass('waiting');
								$('#video-gallery-invalid, #photo-gallery-invalid').removeClass(
									'd-inline-block',
								);
								if ('images' in data.data && data.data.images.length > 0) {
									t.handleToggleTooltip(false);
									t.toggleEmptyPhotosMessage(false);
									$.each(data.data.images, function (i, photo) {
										t.appendPhotoElement(photo);
									});
								}
								if ('videos' in data.data && data.data.videos.length > 0) {
									$('.video-gallery').find('.gallery-video-container').remove();
									$('.video-gallery .empty-gallery-message').hide();
									t.handleToggleTooltip(false);
									$.each(data.data.videos, function (i, video) {
										var thumbnailUrl;
										if ((video.type = 'youtube-video')) {
											var videoMatch = video.url.match(
												/youtube\.com.*(\?v=|\/embed\/)(.{11})/,
											);
											var videoId = videoMatch ? videoMatch.pop() : false;
											var thumbnailUrl = videoId
												? '//img.youtube.com/vi/' + videoId + '/0.jpg'
												: false;
										}
										if (thumbnailUrl) {
											$('.video-gallery').append(
												t.videoTemplate({
													videoUrl: video.url.replace('http://', 'https://'),
													thumbnailUrl: thumbnailUrl,
													videoRef: video.id,
												}),
											);
											videos++;
										}
									});
								}
								updateCompletionPercentages(data.progress, 'photo-and-videos', 'media');

								sectionLoaded($('.images-subsection'));
							},
							function (error) {
								var galleriesErrors = $('#video-gallery-invalid, #photo-gallery-invalid');
								galleriesErrors
									.text(
										_t('seller_settings_photo-video:errors.cant-load'),
									)
									.addClass('d-inline-block');
								$(
									'.photo-gallery .empty-gallery-message, .video-gallery .empty-gallery-message',
								).hide();
								$('.photos-container, .videos-container').removeClass('waiting');
							},
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					updateYoutubeToggle: function (defer) {
						if (t.videosToggle.data('original') === t.videosToggle.prop('checked')) {
							defer.resolve();
							return;
						}
						Bark.api(
							'seller/profile',
							{
								toggles: {
									youtube: t.videosToggle.prop('checked') ? 1 : 0,
								},
							},
							function (data) {
								t.videosToggle.data('original', t.videosToggle.prop('checked'));
								formManager.dirty(t.formManagerHandle, false);
								defer.resolve();
								updateCompletionPercentages(data.progress, 'photo-and-videos', 'media');
							},
							function (data) {
								t.videosToggle.prop('checked', t.videosToggle.data('original'));
								handleToggleSectionHiding(t.videosToggle);
								defer.reject($('.videos-container'));
							},
							'PUT',
							Bark.apiVersionHeader('v2'),
						);
					},
					showPhotoViewModal: function (photoUrl) {
						modalManager.set(
							'',
							'',
							this.photoViewTemplate({
								photoUrl: photoUrl,
							}),
							[],
							['modal-lg'],
						);
					},
					showPhotoDeleteModal: function (photoRef, photoType, photoUrl) {
						modalManager.set(
							'',
							'',
							this.photoDeleteTemplate({
								photoRef: photoRef,
								photoType: photoType,
								photoUrl: photoUrl,
							}),
							[
								modalManager.cancelLinkHTML(),
								modalManager
									.submitButtonHTML(_t('seller_settings_profile:accordion-buttons.delete'), false)
									.replace('btn-primary', 'btn-danger'),
							],
							['modal-xs'],
						);
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							$('.modal-submit').addClass('submit-waiting').prop('disabled', true);
							var id = $('#photo-delete-reference').val();
							var type = $('#photo-delete-type').val();
							Bark.api(
								'seller/media/delete/',
								{
									id: id,
									source: type,
								},
								function (data) {
									$('div').remove('.gallery-photo-' + id + '-container');
									if ($('.gallery-photo-container').length === 0) {
										$('.photo-gallery .empty-gallery-message').show();
									}
									$('#photo-gallery-invalid').removeClass('d-inline-block');
									modalManager.destroy();
									updateCompletionPercentages(data.progress, 'photo-and-videos', 'media');
								},
								function (error) {
									var photo_gallery_error = $('#photo-gallery-invalid');
									photo_gallery_error
										.text(
                                            _t('seller_settings_photo-video:errors.cant-delete')
										)
										.addClass('d-inline-block');
									$('.modal-submit')
										.removeClass('submit-waiting')
										.prop('disabled', false);
									modalManager.destroy();
								},
								'POST',
								Bark.apiVersionHeader('v2'),
							);
						});
					},
					showVideoAddModal: function (videoUrl) {
						modalManager.set(
							_t('seller_settings_photo-video:videos.modal-title'),
							'',
							this.videoAddTemplate({
								videoUrl: videoUrl,
							}),
							[
								modalManager.cancelLinkHTML(),
								modalManager.submitButtonHTML(_t('seller_settings_photo-video:add-link-button'), true),
							],
							['modal-sm'],
						);
						modalManager.setEvent('change', '.video-input', {}, function (e) {
							if ($('.video-input').val() != '')
								$('.modal-submit').prop('disabled', false);
							else $('.modal-submit').prop('disabled', true);
						});
						modalManager.setEvent('keyup', '.video-input', {}, function (e) {
							if ($('.video-input').val() != '')
								$('.modal-submit').prop('disabled', false);
							else $('.modal-submit').prop('disabled', true);
						});
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							$('.modal-submit').addClass('submit-waiting').prop('disabled', true);
							var $form = $('.video-form'),
								videoUrl = $form.find('#video_url').val(),
								formData = new FormData();
							if (!validateYoutubeUrl(videoUrl)) {
								var video_gallery_error = $('#video-gallery-add-invalid');
								video_gallery_error.text(_t('seller_settings_photo-video:errors.invalid-url'));
								video_gallery_error.addClass('d-inline-block');
								$('.video-gallery .empty-gallery-message').hide();
								$('.modal-submit').removeClass('submit-waiting').prop('disabled', false);
								return;
							}
							formData.append('url', videoUrl);
							let videoId = videoUrl.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
							t.videosToSave.push(formData);
							t.appendVideoElement({
								videoId,
								videoUrl,
								thumbnailUrl: `//img.youtube.com/vi/${videoId}/0.jpg`,
								videoRef: `${t.newVideoPrefix}${t.newVideoIndex}`,
								is_new: true,
							});
							t.newVideoIndex++;
							t.addListeners();
							formManager.dirty(t.formManagerHandle, t.videosToSave.length > 0);
							$('.video-gallery .empty-gallery-message').hide();
							$('#video-gallery-invalid').removeClass('d-inline-block');
							modalManager.destroy();
						});
					},
					showVideoDeleteModal: function (videoRef) {
						modalManager.set(
							'',
							'',
							this.videoDeleteTemplate({
								videoRef: videoRef,
							}),
							[
								modalManager.cancelLinkHTML(),
								modalManager
									.submitButtonHTML(_t('seller_settings_photo-video:delete-button'), false)
									.replace('btn-primary', 'btn-danger'),
							],
							['modal-xs'],
						);
						modalManager.setEvent('click', '.modal-submit', {}, function (e) {
							$('.modal-submit').addClass('submit-waiting').prop('disabled', true);
							var type = 'youtube';
							var id = $('.video-delete').val();
							Bark.api(
								'seller/media/delete',
								{
									id: id,
									source: type,
								},
								function (data) {
									$('div').remove(
										'.gallery-video-' + $('.video-delete').val() + '-container',
									);
									if ($('.gallery-video-container').length === 0) {
										$('.video-gallery .empty-gallery-message').show();
									}
									$('#video-gallery-invalid').removeClass('d-inline-block');
									modalManager.destroy();
									updateCompletionPercentages(data.progress, 'photo-and-videos', 'media');
								},
								function (error) {
									var video_gallery_error = $('#video-gallery-invalid');
									video_gallery_error.text(
                                        _t('seller_settings_photo-video:errors.cant-delete-youtube'),
									);
									video_gallery_error.addClass('d-inline-block');
									$('.modal-submit')
										.removeClass('submit-waiting')
										.prop('disabled', false);
									modalManager.destroy();
								},
								'POST',
								Bark.apiVersionHeader('v2'),
							);
						});
					},
					uploadImages: (defer) => {
						if (t.imagesToSave.length === 0) {
							defer.resolve();
							return;
						}
						let deferreds = [];
						let progressObj = {};
						t.imagesToSave.forEach((imageFormData, i) => {
							deferreds[i] = $.Deferred();
							Bark.api(
								'seller/media/image',
								imageFormData,
								function (data) {
									let imgContainerEl = $(
										`.gallery-photo-${t.newPhotoPrefix}${i}-container.is-new`,
									);
									if (data.status) {
										if (imgContainerEl.length === 1) {
											t.appendPhotoElement(
												{
													id: data.image_id,
													type: 'profile-image',
													url: data.image_url,
													photoRef: data.image_id,
												},
												imgContainerEl,
											);
										}
										progressObj = data.progress;
										deferreds[i].resolve();
									} else {
										photo_gallery_error.text(
                                            _t('seller_settings_photo-video:errors.cant-save-image'),
										);
										$('.photo-gallery .empty-gallery-message').hide();
										photo_gallery_error.addClass('d-inline-block');
										deferreds[i].reject();
									}
								},
								function (error) {
									var errorData = handleErrors(error, false);
									var photo_gallery_error = $('#photo-gallery-invalid');
									var msg =
                                        _t('seller_settings_photo-video:errors.cant-save-image');
									if (
										errorData &&
										typeof errorData.validation !== 'undefined' &&
										typeof errorData.validation.image !== 'undefined' &&
										errorData.validation.image.length > 0
									) {
										msg = errorData.validation.image[0];
									}
									photo_gallery_error.text(msg);
									$('.photo-gallery .empty-gallery-message').hide();
									photo_gallery_error.addClass('d-inline-block');
									deferreds[i].reject();
								},
								'POST',
								Bark.apiVersionHeader('v2'),
								false,
								false,
								false,
							);
						});
						$.when(...deferreds).then(
							() => {
								updateCompletionPercentages(progressObj, 'photo-and-videos', 'media');
								defer.resolve();
							},
							() => {
								defer.reject();
							},
						);
					},
					uploadVideos: (defer) => {
						if (t.videosToSave.length === 0) {
							defer.resolve();
							return;
						}
						let deferreds = [];
						t.videosToSave.forEach((videoFormData, i) => {
							deferreds[i] = $.Deferred();
							Bark.api(
								'seller/media/youtube',
								videoFormData,
								function (data) {
									if (data.status) {
										let videoId = data.url
												.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
												.pop(),
											thumbnailUrl = '//img.youtube.com/vi/' + videoId + '/0.jpg',
											videoRef = data.media_id;
										let existing = $(
											`.gallery-video-${t.newVideoPrefix}${i}-container.is-new img[src="${thumbnailUrl}"]`,
										).closest('.gallery-video-container');
										t.appendVideoElement({ thumbnailUrl, videoRef }, existing);
										deferreds[i].resolve();
									} else {
										var video_gallery_error = $('#video-gallery-invalid');
										video_gallery_error.text(
											_t('seller_settings_photo-video:errors.cant-save-video'),
										);
										video_gallery_error.addClass('d-inline-block');
										$('.video-gallery .empty-gallery-message').hide();
										deferreds[i].reject();
									}
									updateCompletionPercentages(data.progress, 'photo-and-videos', 'media');
								},
								function (error) {
									deferreds[i].reject();
									var video_gallery_error = $('#video-gallery-invalid');
									video_gallery_error.text(
                                        _t('seller_settings_photo-video:errors.cant-save-video'),
									);
									video_gallery_error.addClass('d-inline-block');
									$('.video-gallery .empty-gallery-message').hide();
									$('.modal-submit')
										.removeClass('submit-waiting')
										.prop('disabled', false);
								},
								'POST',
								Bark.apiVersionHeader('v2'),
								false,
								false,
								false,
							);
						});
						$.when(deferreds).then(
							() => {
								defer.resolve();
							},
							() => {
								defer.reject();
							},
						);
					},
					addListeners: function () {
						$('.photo-link')
							.off('click.pl')
							.on('click.pl', function (e) {
								e.preventDefault();
								$('.photo-file').trigger('click');
							});
						t.videosToggle
							.off('change.toggle keyup.toggle')
							.on('change.toggle keyup.toggle', () => {
								formManager.dirty(t.formManagerHandle);
								handleToggleSectionHiding(t.videosToggle);
							});
						$('.photo-file')
							.off('change.pf')
							.on('change.pf', function (e) {
								e.preventDefault();
								let files = $(this).get(0).files;
								if (files.length > 0) {
									$('.photo-gallery .empty-gallery-message').hide();
									$('#photo-gallery-invalid').removeClass('d-inline-block');
								}
								for (let i = 0; i < files.length; i++) {
									var formData = new FormData();
									formData.append('image', files[i]);
									t.imagesToSave.push(formData);
									let fileReader = new FileReader();
									let photo = {
										id: t.newPhotoIndex,
										type: 'profile-image',
										url: t.loadingImageUrl,
										photoRef: `${t.newPhotoPrefix}${t.newPhotoIndex}`,
										is_new: true,
									};
									fileReader.onload = (e) => {
										$(`img#gallery-photo-${photo.id}`).attr('src', e.target.result);
									};
									t.newPhotoIndex++;
									t.appendPhotoElement(photo);
									fileReader.readAsDataURL(files[i]);
								}

								$('.photo-file').val('');
								formManager.dirty(t.formManagerHandle, t.imagesToSave.length > 0);
							});
						/*$('.photo-gallery').on('click', '.photo-view', function(e) {
						e.preventDefault();
						t.showPhotoViewModal($(this).find('img').attr('src'));
					});*/
						$('.photo-gallery')
							.off('click.pg')
							.on('click.pg', '.photo-view', function (e) {
								e.preventDefault();
								let photoRef = $(this).find('input[name="photo-reference"]').val();
								if (photoRef.startsWith(t.newPhotoPrefix)) {
									return;
								}
								t.showPhotoDeleteModal(
									photoRef,
									$(this).find('input[name="photo-type"]').val(),
									$(this).find('img').attr('src'),
								);
							});
						$('.video-link')
							.off('click.vl')
							.on('click.vl', function (e) {
								e.preventDefault();
								t.showVideoAddModal();
							});
						$('.video-gallery')
							.off('click.vg')
							.on('click.vg', '.video-view', function (e) {
								e.preventDefault();
								t.showVideoDeleteModal($(this).find('input').val());
							});
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function QuestionAndAnswer() {
				var instanceVars = {
					containerDOM: $('#question-list').get(),
					formManagerHandle: 'profile-qas',
					$containerElement: function () {
						return $(this.containerDOM);
					},
					qaItemTemplate: Handlebars.compile(
						document.getElementById('qa-item-template').innerHTML,
					),
					initialise: function () {
						var t = this;
						formManager.register(
							this.formManagerHandle,
							function (defer) {
								t.setQuestionsAndAnswers(defer);
							},
							function () {
								$('.qa-wrapper textarea').each(function (i) {
									$(this).val($(this).data('original'));
								});
								formManager.dirty(t.formManagerHandle, false);
								removeFormErrors(t.$containerElement());
							},
						);
					},
					populateData: function (selfData) {
						var t = this;
						var qas = selfData.qas;
						let answered = 0;
                        if(qas.length > 0) {
                            qas.forEach(function (qa) {
                                t.$containerElement().append(t.qaItemTemplate(qa));
                                if (qa.answer.length > 0) answered += 1;
                            });
                            sectionLoaded($('.qa-wrapper'));
                            t.addListeners();
                        }
					},
					setQuestionsAndAnswers: function (defer) {
						var t = this;
						var qas = [];
						$('.qa-answer-input').each(function () {
							var $element = $(this);
							qas.push({
								id: $element.data('question-id'),
								answer: $element.val(),
							});
						});
						Bark.api(
							'seller/profile',
							{
								qas: qas,
							},
							function (data) {
								formManager.dirty(t.formManagerHandle, false);
								removeFormErrors(t.$containerElement());
								qas.forEach(function (q, i, arr) {
									$('#answer-' + q.id).data('original', q.answer);
								});
								updateCompletionPercentages(data.progress, 'q-and-a', 'qas');
								defer.resolve();
							},
							function (data) {
								var errorData = handleErrors(data);
								var validationErrors = errorData['validation'];
								var errorArr = [];
								Object.keys(validationErrors).forEach(function (key) {
									var index = parseInt(key.split('.')[1]);
									var message = validationErrors[key][0].replace(key, 'answer');
									var id = qas[index]['id'];
									addFormError($('#answer-' + id), message);
								});
								scrollToFirstError();
								defer.reject();
							},
							'PUT',
							Bark.apiVersionHeader('v2'),
						);
					},
					addListeners: function () {
						var t = this;
						$('.qa-wrapper :input').on('change.update, keyup.change', function () {
							if ($(this).val().trim() != $(this).data('original')) {
								formManager.dirty(t.formManagerHandle);
							}
						});
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				return this;
			}

			function Accreditation() {
				let templates = {};
				let self = this;
				let accreditationRecords = {};

				/**
				 * Show an error message
				 * @param {jQueryable} container
				 * @param {string} message
				 */
				const showRowError = (container, message) => {
					let errorContainer = $('.js-accreditation-row-error', container);
					errorContainer.removeClass('d-none');

					$('.js-msg', errorContainer).text(message);

					$('.js-accreditation-value')
						.off('input.removeErr')
						.one('input.removeErr', () => {
							errorContainer.addClass('d-none');
						});
				};

				/**
				 * Show an error on the modal
				 * @param {string} message
				 */
				const showModalError = (message) => {
					let scope = $('.js-add-accreditation-error-container');

					$('.js-msg', scope).text(message);
					scope.removeClass('d-none');

					$('#add-accreditation-modal :input')
						.off('input.removeErr')
						.one('input.removeErr', () => {
							scope.addClass('d-none');
						});
				};

				/**
				 * Save changes to an accreditation record
				 * @param {object} payload
				 * @param {callback} success
				 * @param {callback} errorFunc
				 */
				const postAccreditations = (accreditations, success, errorFunc) => {
					if (accreditations.length === 0) {
						success && success();
						return;
					}
					Bark.api(
						'seller/profile/accreditations',
						{ accreditations },
						({ status, data, progress }) => {
							if (status) {
								let existing = $(`.js-accreditation-item-${data.id}`);

								if (!existing.length && data.accreditation_id) {
									existing = $(`[data-aid=${data.accreditation_id}]`);
								}

								$('.js-accreditation-empty').addClass('d-none');
								$('.js-accreditation-add-item-header').removeClass('d-none');

								self.addRecordToList(data, existing.length && existing);
								self.bindEvents();

								updateCompletionPercentages(progress, 'accreditations', 'accreditations');

								success && success();
								return;
							}

							errorFunc && errorFunc();
						},
						() => {
							errorFunc && errorFunc();
						},
						'POST',
						Bark.apiVersionHeader('v2'),
					);
				};

				let instanceVars = {
					toggleAccreditations: $('#enable-accreditations'),
					formManageHandle: 'accreditations-toggle',
					formManagerHandle: 'accreditations-bulk-submit-form',
					toDelete: [],
					toSave: [],
					toSaveCustoms: [],
					newEntryPrefix: 'new-accred-',
					newEntryIndex: '1',

					populateSelfData: (selfData) => {
						const toggleAccreditations = selfData.toggles['accreditations'];
						self.toggleAccreditations
							.prop('checked', toggleAccreditations)
							.data('original', toggleAccreditations);
						handleToggleSectionHiding(self.toggleAccreditations);
					},

					updateToggle: (defer) => {
						Bark.api(
							'seller/profile',
							{
								toggles: {
									accreditations: self.toggleAccreditations.prop('checked') ? 1 : 0,
								},
							},
							function (data) {
								self.toggleAccreditations.data(
									'original',
									self.toggleAccreditations.prop('checked'),
								);
								formManager.dirty(self.formManagerHandle, false);
								updateCompletionPercentages(
									data.progress,
									'accreditations',
									'accreditations',
								);
								defer.resolve();
							},
							function (data) {
								self.toggleAccreditations.prop(
									'checked',
									self.toggleAccreditations.data('original'),
								);
								handleToggleSectionHiding(self.toggleAccreditations);
								defer.reject(self.toggleAccreditations);
							},
							'PUT',
							Bark.apiVersionHeader('v2'),
						);
					},

					bindEvents: () => {
						self.toggleAccreditations
							.off('change.toggle keyup.toggle')
							.on('change.toggle keyup.toggle', () => {
								formManager.dirty(self.formManagerHandle);
								handleToggleSectionHiding(self.toggleAccreditations);
							});

						$('.js-add-accreditation')
							.off('click.addAcc')
							.on('click.addAcc', () => {
								$('.js-accreditation-modal-before-upload').removeClass('d-none');
								$('.js-accreditation-modal-after-upload').empty().addClass('d-none');
								$('.js-submit-custom-accreditation').attr({ disabled: 'disabled' });
								$('#custom-accreditation-name').val('');
								$('#custom-accreditation-id').val('');
								$('#add-accreditation-modal').modal('show');
							});

						$('.js-accreditation-trigger-file-upload')
							.off('click.triggerUpload')
							.on('click.triggerUpload', () => {
								$('.js-accreditation-file-elem').trigger('click');
							});

						$('.js-accreditation-file-elem')
							.off('change.uploadFile')
							.on('change.uploadFile', (e) => {
								let t = $(e.target);
								let file = t.get(0).files[0];
								let formData = new FormData();

								if (file.size > 1024 * 1024 * 10) {
									showModalError(_t('seller_settings_accreditation:errors.too-big'));
									$('.js-accreditation-file-elem').val('');
									return;
								}

								e.preventDefault();

								formData.append('file', file);

								Bark.api(
									'seller/accreditation/attachment',
									formData,
									(e) => {
										if (e.status) {
											let container = $('.js-accreditation-modal-after-upload');
											$('.js-accreditation-modal-before-upload').addClass('d-none');

											container.html(
												templates.image({
													file_id: e.data.file_id,
													preview_src: e.data.path,
													is_image: e.data.is_image,
												}),
											);

											container.removeClass('d-none');
											self.bindEvents();
											return;
										}

										if (e.error && e.error.message) {
											showModalError(e.error.message);
										} else {
											showModalError(_t('seller_settings_accreditation:errors.upload-error'));
										}
									},
									() => {
										showModalError(_t('seller_settings_accreditation:errors.upload-error'));
									},
									'POST',
									Bark.apiVersionHeader('v2'),
									false,
									false,
									false,
								);

								t.val('').trigger('input');
							});

						$('.js-remove-accreditation-image')
							.off('click.remove')
							.on('click.remove', () => {
								$('.js-accreditation-modal-before-upload').removeClass('d-none');
								$('.js-accreditation-modal-after-upload').empty().addClass('d-none');
								$('.js-submit-custom-accreditation')
									.removeAttr('disabled')
									.removeClass('submit-waiting');
							});

						$('.js-accreditation-add-suggested')
							.off('click.addSuggested')
							.on('click.addSuggested', ({ target }) => {
								let scope = $(target).closest('.js-accreditation-item');
								let data = scope.data();
								let valueElem = $('.js-accreditation-value', scope);
								let placeholder = valueElem.attr('placeholder') || 'value';
								let payload = {
									id: data.id,
									name: null,
									value: valueElem.val(),
									file_id: null,
									accreditation_id: data.aid,
								};
								let key = `${data.id}_${data.aid}`;
								let record = accreditationRecords[key];

								if (!payload.value) {
									showRowError(scope, _t('seller_settings_accreditation:errors.enter-valid-item'));
									return;
								}

								if (
									record.validation_pattern &&
									!payload.value.match(new RegExp(record.validation_pattern))
								) {
									showRowError(scope, _t('seller_settings_accreditation:errors.enter-valid-item'));
									return;
								}
								self.toSave.push(payload);
								self.addRecordToList(payload);
								self.bindEvents();
								formManager.dirty(self.formManagerHandle, self.toSave.length > 0);
							});

						$('.js-accreditation-file-elem,#custom-accreditation-name')
							.off('input.remDisabled')
							.on('input.remDisabled', () => {
								$('.js-submit-custom-accreditation')
									.removeAttr('disabled')
									.removeClass('submit-waiting');
							});

						$('.js-edit-accreditation-value')
							.off('click.edit')
							.on('click.edit', ({ target }) => {
								let scope = $(target).closest('.js-accreditation-item');

								$('.js-accreditation-preview-view', scope).addClass('d-none');
								$('.js-accreditation-edit-view', scope).removeClass('d-none');
							});

						$('.js-edit-accreditation-custom-value')
							.off('click.edit')
							.on('click.edit', ({ target }) => {
								let scope = $(target).closest('.js-accreditation-item');
								let imageContainer = $('.js-accreditation-modal-after-upload');
								let { id, aid } = scope.data();
								let key = `${id}_${aid}`;
								let record = accreditationRecords[key];

								$('.js-add-accreditation').click();

								$('#custom-accreditation-name').val(record.name);
								$('#custom-accreditation-id').val(record.id);

								if (record.file_path) {
									$('.js-accreditation-modal-before-upload').addClass('d-none');

									imageContainer.html(
										templates.image({
											file_id: record.file_id,
											preview_src: record.file_path,
											is_image: record.file_is_image,
										}),
									);

									imageContainer.removeClass('d-none');
								}

								self.bindEvents();
							});

						$('.js-submit-custom-accreditation')
							.off('click.saveCustom')
							.on('click.saveCustom', ({ target }) => {
								let t = $(target);
								let id =
									$('#custom-accreditation-id').val() ||
									`${self.newEntryPrefix}${self.newEntryIndex}`;
								self.newEntryIndex += 1;
								let payload = {
									id: id,
									name: $('#custom-accreditation-name').val().trim(),
									value: null,
									file_id: $('#accreditation-file-id').val() || null,
									accreditation_id: null,
								};

								if (payload.name.length < 5) {
									$('.js-add-accreditation-error-container');
									showModalError(_t('seller_settings_accreditation:errors.name-too-short'));
									return;
								}

								t.attr({ disabled: 'disabled' }).addClass('submit-waiting');
								self.toSaveCustoms.push(payload);
								self.addRecordToList(payload);
								self.bindEvents();
								formManager.dirty(self.formManagerHandle, self.toSaveCustoms.length > 0);
								t.removeClass('submit-waiting');
								$('#add-accreditation-modal').modal('hide');
							});

						$('.js-delete-accreditation')
							.off('click.delete')
							.on('click.delete', ({ target }) => {
								let row = $(target).closest('.js-accreditation-item');
								let id = row.data('id');
								self.toDelete.push(id);
								formManager.dirty(self.formManagerHandle, self.toDelete.length > 0);
								row.addClass('to-be-deleted');
							});
					},

					/**
					 * Reset the form
					 */
					reset: () => {
						$('.js-accreditation-container').empty();
						$('.js-seller-accreditation').addClass('waiting');
						formManager.dirty(self.formManagerHandle, false);
						self.toSave = [];
						self.toDelete = [];
						self.toSaveCustoms = [];
						self.initialise();
					},
					registerFormManager: () => {
						formManager.register(
							self.formManagerHandle,
							function (defer) {
								self.updateToggle(defer);
								let d1 = $.Deferred();
								let d2 = $.Deferred();
								let d3 = $.Deferred();
								postAccreditations(
									self.toSave.map((item) => {
										if (String(item.id).startsWith(self.newEntryPrefix)) {
											delete item.id;
										}
										return item;
									}),
									() => d1.resolve(),
									() => d1.reject(),
								);
								postAccreditations(
									self.toSaveCustoms.map((item) => {
										if (String(item.id).startsWith(self.newEntryPrefix)) {
											delete item.id;
										}
										return item;
									}),
									() => d2.resolve(),
									() => d2.reject(),
								);
								self.uploadDeletions(d3);
								$.when(d1, d2, d3).then(
									() => {
										self.reset();
										defer.resolve();
									},
									() => {
										defer.reject();
									},
								);
							},
							function () {
								// same same with save/delete just reset them
								self.toggleAccreditations.prop(
									'checked',
									self.toggleAccreditations.data('original'),
								);
								handleToggleSectionHiding(self.toggleAccreditations);
								self.reset();
							},
						);
					},
					/**
					 * Initialise the accreditation data
					 */
					initialise: () => {
						templates.main = Handlebars.compile(
							document.getElementById('accreditation-item-template').innerHTML,
						);
						templates.image = Handlebars.compile(
							document.getElementById('accreditation-uploaded-image-template').innerHTML,
						);

						Bark.api(
							'seller/accreditation',
							{},
							({ status, data }) => {
								status && self.populateData(data);
							},
							null,
							'GET',
							Bark.apiVersionHeader('v2'),
						);
					},
					getRowElById: (id) => {
						return $(`.js-accreditation-item[data-id="${id}"]`);
					},
					uploadDeletions: (defer) => {
						if (self.toDelete.length === 0) {
							defer.resolve();
							return;
						}
						let payload = {
							accreditation_ids: self.toDelete,
						};
						Bark.api(
							`seller/profile/accreditations/delete`,
							payload,
							({ progress }) => {
								updateCompletionPercentages(progress, 'accreditations', 'accreditations');
								defer.resolve();
							},
							() => {
								defer.reject();
							},
							'POST',
							Bark.apiVersionHeader('v2'),
						);
					},

					/**
					 * Add a record to the list of accreditations
					 * @param {object} record
					 * @param {jQueryable|null} replace
					 */
					addRecordToList: (record, replace = null) => {
						let elem;
						let func;
						let id = record.id || '';
						let aid = record.accreditation_id || '';
						let key = `${id}_${aid}`;
						accreditationRecords[key] = record;
						replace = replace ?? $(`.js-accreditation-item[data-id="${id}"]`);
						if (replace.length > 0) {
							elem = replace;
							func = 'replaceWith';
						} else {
							elem = $('.js-accreditation-container');
							func = 'append';
						}

						elem[func](
							templates.main({
								id: record.id || '',
								name: record.name,
								description: record.description,
								is_text: record.value_type === 'text',
								placeholder: record.placeholder,
								preview_label: record.accreditation_id
									? record.placeholder || record.name
									: record.name,
								edit_view_class: record.accreditation_id && !record.value ? '' : 'd-none',
								preview_view_class:
									record.accreditation_id && !record.value ? 'd-none' : '',
								value: record.value,
								file_path: record.file_path,
								file_name: record.file_name,
								accreditation_id: record.accreditation_id || '',
								accreditation_logo: record.accreditation_logo,
							}),
						);
					},

					/**
					 * Populate data for the accreditation
					 * @param {object} data
					 */
					populateData: (data) => {
						let emptyContainer = $('.js-accreditation-empty');
						$('.js-seller-accreditation').removeClass('waiting');

						emptyContainer.addClass('d-none');

						if (data && data.length) {
							$('.js-accreditation-add-item-header').removeClass('d-none');

							data.forEach((item) => {
								self.addRecordToList(item);
							});
						} else {
							$('.js-accreditation-add-item-header').addClass('d-none');
							emptyContainer.removeClass('d-none');
							let toggleEl = $('.js-seller-accreditation').find('.switch[checked]');
							if (toggleEl.length === 1) {
								toggleEl.parent().parent().find('.toggle-info').addClass('auto-tooltip');
							}
						}

						sectionLoaded($('.js-seller-accreditation'));
						self.bindEvents();
					},
				};

				Object.assign(this, instanceVars);
				this.initialise();
				this.registerFormManager();
				return this;
			}

			function ProgressBar() {
				var instanceVars = {
					message: '',
					percentage: 0,
					prevPercentage: 0,
					breakdown: {},
					links: [],
					breakdownAnchors: {
						profile_data: 'general-information',
						reviews: 'reviews',
						links: 'social-media-and-links',
						media: 'photo-and-videos',
						services: 'services-prices',
						accreditations: 'accreditations',
						qas: 'q-and-a',
					},
					trophyTimeout: null,
					completionTextEl: $('.completion-container'),
					progressTextEl: $('.progress-container'),
					progressContainer: $('.profile-progress'),
					completionTrophy: $('.profile-progress .completion-trophy'),
					initialise: function () {
						let t = this;
						t.getProgress();
						if ($('.services-completion').length > 0)
							t.breakdownAnchors.services = 'services';
						// add fun listener for the trophy
						$('span.bark-svg-icon.completion-trophy')
							.off('click.fun')
							.on('click.fun', t.blastTrophyConfetti);
					},
					blastTrophyConfetti: function (e) {
						let t = this;
						const trophy = $('span.bark-svg-icon.completion-trophy');
						e = e ?? {
							clientX: trophy.offset().left + trophy.width() / 2 - $(window).scrollLeft(),
							clientY: trophy.offset().top + trophy.height() / 4 - $(window).scrollTop(),
						};
						if (!t.trophyTimeout) {
							trophy.addClass('completion-pulse');
							blastConfetti(null, e, true);
						}
					},
					getProgress: function () {
						var t = this;
						Bark.api(
							'seller/profile/progress',
							{},
							function (data) {
								bugsnagClient.leaveBreadcrumb('ProgressBar:getProgress response', {
									data: JSON.stringify(data),
								});
								t.percentage = data.percent;
								t.message = t.getEncouragementMessage(t.percentage);
								t.links = data.links;
								t.breakdown = data.breakdown_percentages;
								$('.profile-progress.waiting').removeClass('waiting');
								t.updateProgress();
								// automaticaly open first section if low completion percentage
								if (!QS.hasKey('ps') && t.percentage < 25) {
									const to = setTimeout(() => {
										if ($('.card-header').not('.collapsed').length == 0) {
											$('#general-information-heading').click();
										}
										clearTimeout(to);
									}, 1000);
								}
								if (t.breakdown) {
									Object.keys(t.breakdown).forEach((sectionName) => {
										setSectionCompletion(
											t.breakdownAnchors[sectionName],
											t.breakdown[sectionName],
											false,
										);
									});
								}
							},
							function (data) {
							},
							'GET',
							Bark.apiVersionHeader('v3'),
						);
					},
                    getEncouragementMessage: function (percentComplete) {
					    let message = ''
                        if(percentComplete <= 35) {
                            message = _t('seller_settings_profile:completeness.messages.take-two-minutes');
                        }
                        if(percentComplete > 35 && percentComplete <= 60) {
                            message = _t('seller_settings_profile:completeness.messages.getting-there');
                        }
                        if(percentComplete > 60 && percentComplete <= 99) {
                            message = _t('seller_settings_profile:completeness.messages.looking-good');
                        }
                        if(percentComplete === 100) {
                            message = _t('seller_settings_profile:completeness.messages.complete');
                        }
                        return message;
                    },
					updateProgress: function (allowFun) {
						let t = this;
						let color = 'danger';
						let showTrophyConfetti =
							t.percentage === 100 &&
							t.prevPercentage < 100 &&
							!t.progressContainer.hasClass('complete');
						if (allowFun && showTrophyConfetti) {
							setTimeout(() => {
								[1, 0.6, 0.4].forEach((h) => {
									setTimeout(() => {
										blastConfettiFromSides(h);
									}, (1.0 - h) * 800);
								});
								setTimeout(t.blastTrophyConfetti, 1000);
							}, 1200);
						}
						t.prevPercentage = t.percentage;
						t.completionTrophy.removeClass('completion-pulse');
						t.progressContainer
							.removeClass('complete', 'incomplete')
							.toggleClass('incomplete', t.percentage < 100)
							.toggleClass('complete', t.percentage === 100);
						if (t.percentage >= 60) {
							color = 'success';
						} else if (t.percentage > 10) {
							color = 'warning';
						}

						$('.profile-progress .progress-bar')
							.css('width', t.percentage + '%')
							.removeClass(['bg-danger', 'bg-warning', 'bg-success', 'bg-primary'])
							.addClass('bg-' + color);
						$('.profile-progress .progress-title').html(
                            _t('seller_settings_profile:completeness.messages.x-percent-complete', {
                                wrap: `<span class="font-weight-bold text-${color}">`,
                                percentage_number: t.percentage,
                                endwrap: "</span>",
                                interpolation: { escapeValue: false }
                            })
						);
						$('.profile-progress .progress-message')
							.removeClass(['text-danger', 'text-warning', 'text-success'])
							.addClass('text-' + color)
							.html(t.message);
						$('.profile-progress .progress-bar .check-circle')
							.removeClass([
								'bsi-primary-danger',
								'bsi-primary-warning',
								'bsi-primary-success',
							])
							.addClass(`bsi-primary-${color}`);
					},
				};

				Object.assign(this, instanceVars);

				this.initialise();

				return this;
			}

			var PubSub = {
				on: function (ev, callback) {
					if (Array.isArray(ev)) {
						var pubsub = this;
						ev.forEach(function (e) {
							pubsub.on(e, callback);
						});
					} else {
						var calls = this._callbacks || (this._callbacks = {});
						(this._callbacks[ev] || (this._callbacks[ev] = [])).push(callback);
					}
					return this;
				},

				fire: function () {
					var args = Array.prototype.slice.call(arguments, 0);

					var ev = args.shift();

					if (typeof window.verbosity !== 'undefined' && window.verbosity > 5) {
						console.log(ev + ' happened');
					}

					var list, calls, i, l;

					if (!(calls = this._callbacks)) return this;
					if (!(list = this._callbacks[ev])) return this;

					for (i = 0, l = list.length; i < l; i++) list[i].apply(this, args);
					return this;
				},
			};

			function addFormError($element, errorMessage) {
				var $group = $element.closest('.form-group');
				$group.find('.invalid-feedback').text(errorMessage);
				$element.addClass('is-invalid');
			}

			function removeFormErrors($parentElement) {
				$parentElement.find('.is-invalid').removeClass('is-invalid');
			}

			function scrollToFirstError() {
				var firstError = $('.is-invalid').first();
				if (firstError.length > 0) {
					quickScroll(firstError, -150);
				}
			}

			function startSubmit($submitElement) {
				$submitElement.addClass('submit-waiting');
				$submitElement.addClass('disabled');
			}

			function endSubmit($submitElement, successMessage) {
				$submitElement.removeClass('submit-waiting');
				$submitElement.removeClass('disabled');
				if (successMessage) {
					$submitElement.find('.submit-success-text').text(successMessage);
					$submitElement
						.addClass($submitElement.data('success-class'))
						.removeClass($submitElement.data('default-class'))
						.addClass('submit-success');
					setTimeout(function () {
						$submitElement
							.removeClass($submitElement.data('success-class'))
							.addClass($submitElement.data('default-class'))
							.removeClass('submit-success');
					}, 2500);
				}
			}

			function handleErrors(errorResponse, defaultMessage) {
				var message = _t('seller_settings_profile:generic-error');
				if (typeof defaultMessage !== 'undefined') {
					message = defaultMessage;
				}
				var fallbackError = true;
				var validationObj = {};
				if (typeof errorResponse.status !== 'undefined') {
					if (
						typeof errorResponse.responseJSON !== 'undefined' &&
						typeof errorResponse.responseJSON.error !== 'undefined'
					) {
						var errorObj = errorResponse.responseJSON.error;
						if (errorObj.status_code < 500 && typeof errorObj.message !== 'undefined') {
							message = errorObj.message;
						}
						if (errorObj.status_code === 422 && typeof errorObj.errors !== 'undefined') {
							validationObj = errorObj.errors;
							fallbackError = false;
						}
					}
				}
				if (fallbackError) {
					// for now just through alert
					return {
						message: message,
					};
				} else {
					return {
						message: message,
						validation: validationObj,
					};
				}
			}

			function nl2br(str, is_xhtml) {
				var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
				return (str + '').replace(
					/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
					'$1' + breakTag + '$2',
				);
			}

			function format_currency(number_pence, abbreviate, currencySymbol) {
				var priceVal = number_pence / 100.0;
				if (abbreviate) {
					if (priceVal >= 1000000) {
						priceVal = number_format(priceVal / 1000000, 1) + 'M';
					} else if (priceVal >= 1000) {
						priceVal = number_format(priceVal / 1000, 1) + 'K';
					} else if (priceVal >= 100) {
						priceVal = number_format(priceVal, 0);
					} else {
						priceVal = priceVal ? number_format(priceVal, 2) : 0;
					}
				} else {
					priceVal = number_format(priceVal, 2);
				}
				return '' + currencySymbol + priceVal;
			}

			function handleToggleSectionHiding(el) {
				const selector = el.data('target-fields');
				if (el.prop('checked')) {
					$(`.${selector}`).slideDown();
				} else {
					$(`.${selector}`).slideUp();
				}
			}

			/**
			 * When a section loads in for the first time we need to be sure its made visible.
			 * Also open the section if its the page target
			 * @param el
			 * @param success
			 */
			function sectionLoaded(el) {
				let target = el.closest('.card').find('.card-header .status-icons');
				let sectionId = target.closest('.card-header').prop('id');
				if (
					isFirstSectionToBeLoaded &&
					QS.hasKey('ps') &&
					QS.getValue('ps', false) + '-heading' == sectionId
				) {
					isFirstSectionToBeLoaded = false;
					scrollToAndOpenTargetSection(sectionId);
				}
				el.removeClass('waiting');
				setupSectionButtonListeners(sectionId);
			}

			function scrollToAndOpenTargetSection(sectionId, delay = 500) {
				const to = setTimeout(() => {
					// if all sections are still collapsed, open this section/optionally scroll to specific target
					if ($('.card-header').not('.collapsed').length == 0) {
						const sectionHeader = $('#' + sectionId);
						sectionHeader.click();
						let offset = -Bark.getHeaderHeight();
						const target = QS.getValue('sti', sectionId);
						if (QS.getValue('sti', false)) {
							const sectionHeaders = sectionHeader
								.parent()
								.prevAll('.card:visible')
								.get();
							const sectionHeaderOffset = sectionHeaders.reduce((card) => {
								const $c = $(card);
								return $c.is('visible') ? $c.height() : 0;
							}, 0);
							const targetOffset = Math.max($(`#${target}`).height(), 30);
							offset = offset - sectionHeaderOffset - targetOffset;
							QS.deleteValue('sti');
						}
						setTimeout(() => {
							window.quickScroll(`#${target}`, offset);
						}, 150);
					}
					clearTimeout(to);
				}, delay);
			}

			/**
			 * Real form manager is hidden, so we need to listen to form manager events and update the button states for the visible buttons in this section
			 * @param sectionId
			 */
			function setupSectionButtonListeners(sectionId) {
				let submitBtn = $(`.confirmation-buttons.${sectionId}-buttons .submit-section`);
				submitBtn
					.off(`click.submit-${sectionId}`)
					.on(`click.submit-${sectionId}`, (e) => {
						e.preventDefault();
						forwardEventsToFormManager(sectionId, submitBtn);
					});
				$(`.confirmation-buttons.${sectionId}-buttons .cancel-section`)
					.off('click.confirmations')
					.on('click.confirmations', () => {

						if (formManager.hasDirties()) {
							formManager.cancel();
							$('#form-manager #form-manager-cancel').trigger('click');
						}

						$(`#${sectionId}.card-header`)
							.closest('.card')
							.find('.collapse')
							.collapse('hide');
					});
				formManager.onDirtyStateChange((isInDirtyState) => {
					submitBtn.toggleClass('disabled', !isInDirtyState);
					$(`#${sectionId}.card-header`)
						.not('.collapsed')
						.toggleClass('has-unsaved-changes', isInDirtyState === 1);
				});
			}

			/**
			 * For buttons inside the accordion layout, we still use the form manager that is stickied to the bottom of the page, its just invisible
			 * This forwards all events from the visible button (provided as params) to the hidden buttons
			 * @param sectionId
			 * @param submitBtn
			 */
			function forwardEventsToFormManager(sectionId, submitBtn) {

				if (formManager.hasDirties()) {
					submitBtn.addClass('submit-waiting');
					$('#form-manager #form-manager-save')
						.on(
							`submit_completed.${sectionId}`,
							(event, { successMessage, extraClass, failed }) => {

								submitBtn
									.removeClass('submit-waiting')
									.find('span.submit-text')
									.text(successMessage);
								if (extraClass) {
									submitBtn.removeClass('btn-success').addClass(extraClass);
								}
								if (!failed) {
									$(`#${sectionId}.card-header`)
										.removeClass('has-unsaved-changes')
										.closest('.card')
										.find('.collapse')
										.collapse('hide');
								}
							},
						)
						.on(
							`submit_reset.${sectionId}`,
							(event, { successClass, extraClass, failed }) => {
								submitBtn
									.removeClass(extraClass)
									.addClass('btn-success')
									.find('span.submit-text')
									.text(_t('seller_settings_profile:accordion-buttons.save'));
							},
						)
						.trigger('click');
				}
			}

			/**
			 * Helper function when a new progress data object is returned from the API, to update progress bars and sections
			 * @param progress
			 * @param classname The target class for the completion icon  (usually the profile_section.anchor value in twig)
			 * @param percentageKey
			 */
			function updateCompletionPercentages(progress, classname, percentageKey) {
				if (!progress || !progress.breakdown_percentages) {
					return;
				}
				if (classname === 'services' && $('.services-prices-completion').length > 0) {
					classname = 'services-prices';
				}
				setSectionCompletion(
					classname,
					progress.breakdown_percentages[percentageKey],
					true,
				);
				setTimeout(() => {
					progressBar.percentage = progress.percent;
					progressBar.message = progress.message;
					progressBar.updateProgress(true);
				}, 2100);
			}

			/**
			 * handles firing the completion animation when a section is loaded or its progress gets updated
			 * @param classname
			 * @param percentage
			 * @param allowFun
			 */
			function setSectionCompletion(classname, percentage, allowFun) {
				let completionIcon = $(`.${classname}-completion`);
				completionIcon.removeClass('waiting');
				completionIcon.find('path.tick').toggleClass('primary-color-grey-100', true);
				completionIcon.find('path.tick').toggleClass('primary-color-success', false);
				if (percentage >= 0) {
					if (allowFun) {
						completionAnimationHandler(completionIcon, percentage, allowFun);
					} else {
						setTimeout(() => {
							completionAnimationHandler(completionIcon, percentage, false);
						}, 100);
					}
				}
			}

			/**
			 * Redraws the path around the subsection completion icons
			 * @param completionIcon jQuery element of the completion icon to be manipulated
			 * @param percentage
			 * @param allowFun If completion reached 100% do we want to do celeberations or skip (false for initial page load)
			 */
			function completionAnimationHandler(completionIcon, percentage, allowFun) {
				let percentagePath = completionIcon.find('.completion svg path.percentage');
				let prevPercentage = percentagePath.data('prev-percentage') ?? 0;
				let pathLength = percentagePath.prop('pathLength')?.baseVal ?? 0;
				let adjustedPathlength =
					percentage < 99 ? Math.round((pathLength / 100.0) * percentage) : pathLength;
				// only animate if we've increased our completion % so we don't do the fun events when it didnt actually change
				allowFun = allowFun && prevPercentage < percentage;
				if (allowFun) {
					$('html, body').animate(
						{
							scrollTop: 0,
						},
						100,
					);
				}
				completionIcon
					.find('span.completion')
					.toggleClass('completion-pulse', false)
					.find('path.tick')
					.toggleClass('primary-color-success', percentage > 99)
					.toggleClass('primary-color-grey-100', percentage < 100);
				percentagePath
					.attr('stroke-dasharray', `${adjustedPathlength}, ${pathLength}`)
					.data('prev-percentage', percentage)
					.toggleClass('progress-0', percentage === 0);

				if (allowFun && percentage > 99) {
					// delay the confetti until the progress animation completes
					setTimeout(() => {
						completionIcon.find('span.completion').toggleClass('completion-pulse', true);
						blastConfetti(completionIcon);
					}, 1400);
				}
			}

			function ConfettiManager() {
				const instanceVars = {
					colors: [
						'#2D7AF1',
						'#2D7AF1',
						'#2D7AF1',
						'#2D7AF1',
						'#e6e7ec',
						'#9da0b6',
						'#47bf9c',
						'#47bf9c',
						'#47bf9c',
						'#9da0b6',
						'#47bf9c',
						'#9da0b6',
						'#47bf9c',
						'#111637',
						'#47bf9c',
					],
					blastConfettiFromSides: (height) => {
						let t = this;
						height = height ?? Math.random() * 0.4 + 0.2;
						t.confetti({
							origin: { x: 0, y: height },
							angle: 60,
							spread: 55,
							ticks: 100, // remove ticks and particleCount from both calls to make this more cpu intensive (but awesomer)
							particleCount: 100,
						});
						t.confetti({
							origin: { x: 1, y: height },
							angle: 120,
							spread: 55,
							ticks: 100,
							particleCount: 100,
						});
					},
					blastConfetti: (centerOnElement, mouseEvent, extraFun) => {
						let t = this;
						if (centerOnElement) {
							origin = {
								x:
									(centerOnElement.offset().left - $(window).scrollLeft()) /
									$(window).width(),
								y:
									(centerOnElement.offset().top - $(window).scrollTop()) /
									$(window).height(),
							};
						} else if (mouseEvent) {
							origin = {
								x: mouseEvent.clientX / $(window).width(),
								y: mouseEvent.clientY / $(window).height(),
							};
						} else {
							origin = { x: 0.5, y: 0.5 };
						}
						t.confetti({
							origin,
							startVelocity: extraFun ? Math.random() * 30 + 20 : 25,
							particleCount: extraFun ? 200 : 300,
							gravity: extraFun ? 1.3 : 1.4,
							ticks: extraFun ? 150 : 300,
						});
					},
					confetti: (args) => {
						window.confetti({
							disableForReducedMotion: true,
							zIndex: 99999,
							angle: 90,
							spread: 360,
							colors: this.colors,
							ticks: 150,
							gravity: 1,
							particleCount: 200,
							origin: { x: 0.5, y: 0.5 },
							...args,
						});
					},
				};
				Object.assign(this, instanceVars);

				return this;
			}

			function blastConfettiFromSides(height) {
				confettiManager = confettiManager ?? new ConfettiManager();
				confettiManager.blastConfettiFromSides(height);
			}

			/** Given an element or a mouseevent, it will trigger a confetti animation in a circle around it.
			 * Can be made extra fun to blast more confetti with some randomness
			 * ExtraFun confetti is faster and more numerous but also dissappears faster (so you can fire it more often which is more fun)
			 *
			 *
			 * @param centerOnElement False or A jQuery element which the confetti will center on
			 * @param mouseEvent False or a Event object which contains clientX and clientY properties to position the confetti
			 * @param extraFun Boolean -- true increases the particle count, makes them fall faster, and disappear quicker.
			 */
			function blastConfetti(centerOnElement, mouseEvent, extraFun) {
				confettiManager = confettiManager ?? new ConfettiManager();
				setTimeout(() => {
					confettiManager.blastConfetti(centerOnElement, mouseEvent, extraFun);
				}, 500);
			}

			function setupToggleTooltips() {
				$('a.toggle-info')
					.off('click.notLink')
					.on('click.notLink', (e) => {
						e.preventDefault();
					});

				$('.make-location-private-info').tooltip({
					title:
						_t('seller_settings_profile:about.company-location-section.dont-show-location.tooltip'),
					template:
						'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner text-xs" style="max-width: 240px;"></div></div>',
					trigger: 'hover focus',
				});

				$('.toggle-info')
					.tooltip({
						title:
                            _t('seller_settings_profile:optional-tooltip'),
						template:
							'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner text-xs" style="max-width: 240px;"></div></div>',
						trigger: 'hover focus',
					})
					.off('shown.bs.tooltip.showonce')
					.on('shown.bs.tooltip.showonce', () => {
						hasToggleTooltipDisplayed = true;
					});
				$('.card')
					.off('shown.bs.collapse.showtooltip')
					.on('shown.bs.collapse.showtooltip', () => {
						if (hasToggleTooltipDisplayed) {
							$('.card').off('shown.bs.collapse.showtooltip');
							return;
						}
						let tooltips = $('.toggle-info.auto-tooltip:visible');
						if (tooltips.length === 1) {
							tooltips.focus(); //focus will trigger the tooltip
						} else if (tooltips.length > 1) {
							tooltips[0].focus(); //focus will trigger the tooltip
						}
					})
					.off('hide.bs.collapse.hidetooltip')
					.on('hide.bs.collapse.hidetooltip', () => {
						$('.toggle-info').tooltip('hide');
					});
			}

			// todo can any of these be moved out of this file?
			var progressBar = new ProgressBar();
			var generalInformation = new GeneralInformation();
			var reviews = new Reviews();
			var photosAndVideos = new PhotosAndVideos();
			var services = new Services();
			var prices = new Prices();
			var socialMediaWebLinks = new SocialMediaWebLinks();
			var questionAndAnswer = new QuestionAndAnswer();
			let accreditation = new Accreditation();
			let isFirstSectionToBeLoaded = true;
			let hasToggleTooltipDisplayed = false;
			var confettiManager = new ConfettiManager();

			//Init profile reviews section
			const profileImportReviews = ProfileImportReviews();

			Bark.api(
				'seller/self',
				{},
				({ data }) => {
					if (Array.isArray(data.links) && data.links.length == 0) {
						data.links = {};
					}
					generalInformation.populateData(data);
					socialMediaWebLinks.populateData(data);
					questionAndAnswer.populateData(data);
					photosAndVideos.populateData(data);
					accreditation.populateSelfData(data);
					setupToggleTooltips();
					profileImportReviews.init(data);
				},
				(error) => {},
				'GET',
			);
			let readReviewNotifications = false;
		};

		if ($('#my_profile').length > 0) {
			$('#my_profile').removeClass('waiting');
			$('body').addClass('settings-page');
			MyProfileSettings();
		}
	} catch (e) {
		console.log(e);
	}
}
